import { until, useTimeoutPoll } from "@vueuse/core";
import { ref } from "vue";
//#region \0rolldown/runtime.js
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJSMin = (cb, mod) => () => (mod || (cb((mod = { exports: {} }).exports, mod), cb = null), mod.exports);
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
	value: mod,
	enumerable: true
}) : target, mod));
//#endregion
//#region src/api/retryCalls.ts
/**
* Retries callback parameter if the initial call fails.
*/
var retry = async (callback, retries = 1) => {
	try {
		return await callback();
	} catch (error) {
		if (retries) return retry(() => callback(), retries - 1);
		throw error;
	}
};
//#endregion
//#region src/api/pollUntil.ts
/**
* Polls a function until the given check condition returns true.
* Resolves with the last produced value if successful, or undefined on timeout.
*
* @template T Type of the produced value
* @param fn Function that produces a value on each poll iteration
* @param checkCondition Predicate that determines when polling should stop
* @param options Polling configuration options
* @returns The last produced value if the condition succeeds, otherwise `undefined` on timeout
*/
var pollUntil = async (fn, checkCondition, { interval = 1e3, timeout = 1e4, onError } = {}) => {
	const lastValue = ref();
	const isDone = ref(false);
	const { pause } = useTimeoutPoll(async () => {
		try {
			const value = await fn();
			lastValue.value = value;
			if (await checkCondition(value)) {
				isDone.value = true;
				pause();
			}
		} catch (error) {
			if (typeof onError === "function") onError(error);
		}
	}, interval);
	await until(isDone).toBeTruthy({
		timeout: timeout + interval,
		throwOnTimeout: true
	}).catch(() => pause());
	return isDone.value ? lastValue.value : void 0;
};
//#endregion
//#region src/array/chunk/chunk.ts
/**
* Splits an array into multiple arrays of (closest to) equal size
* @example
* splitEqualSize(new Array(60), 50) // 2 arrays with both of them being 30 length
* splitEqualSize(new Array(61), 50) // 2 arrays with the first being 31 length and the second being 30
* splitEqualSize(new Array(91), 50) // 3 arrays with the lengths being 31, 30 and 30
*/
var splitEqualSize = (array, maxSize) => {
	const totalChunks = Math.ceil(array.length / maxSize);
	const baseSize = Math.floor(array.length / totalChunks);
	const remainder = array.length % totalChunks;
	const result = [];
	let start = 0;
	for (let i = 0; i < totalChunks; i++) {
		const chunkSize = baseSize + (i < remainder ? 1 : 0);
		result.push(array.slice(start, start + chunkSize));
		start += chunkSize;
	}
	return result;
};
//#endregion
//#region src/array/index.ts
/* c8 ignore start */
var array = { splitEqualSize };
//#endregion
//#region src/brackets/findPriceForBracketRangeId/findPriceForBracketRangeId.ts
/**
* Find the first price for a bracket range.
*
* @param {number} id
* @param {Price[]} prices
* @returns {Price | undefined}
*/
var findPriceForBracketRangeId = (bracketRangeId, prices) => {
	return prices.find((price) => price.bracket_range_id === bracketRangeId);
};
//#endregion
//#region src/brackets/isCustomProductBracketRange/isCustomProductBracketRange.ts
/**
* Check if the bracket is a custom bracket.
* Custom brackets have no id.
*
* @param {ProductBracketRange} bracket
* @returns {boolean}
*/
var isCustomProductBracketRange = (bracket) => {
	return bracket.id === null;
};
//#endregion
//#region src/bank/isValidIban.ts
/**
* IBAN validation: no country whitelist, just structure + checksum.
*/
var isValidIban = (value) => {
	if (!value) return false;
	const iban = value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
	if (iban.length < 15 || iban.length > 34) return false;
	if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(iban)) return false;
	const expanded = (iban.slice(4) + iban.slice(0, 4)).replace(/[A-Z]/g, (ch) => (ch.charCodeAt(0) - 55).toString());
	let remainder = 0;
	for (let i = 0; i < expanded.length; i += 7) {
		const part = String(remainder) + expanded.substring(i, i + 7);
		remainder = Number(BigInt(part) % 97n);
	}
	return remainder === 1;
};
//#endregion
//#region ../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function r$1(e) {
	var t, f, n = "";
	if ("string" == typeof e || "number" == typeof e) n += e;
	else if ("object" == typeof e) if (Array.isArray(e)) {
		var o = e.length;
		for (t = 0; t < o; t++) e[t] && (f = r$1(e[t])) && (n && (n += " "), n += f);
	} else for (f in e) e[f] && (n && (n += " "), n += f);
	return n;
}
function clsx() {
	for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r$1(e)) && (n && (n += " "), n += t);
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/tailwind-merge@2.3.0/node_modules/tailwind-merge/dist/bundle-mjs.mjs
var CLASS_PART_SEPARATOR = "-";
function createClassUtils(config) {
	const classMap = createClassMap(config);
	const { conflictingClassGroups, conflictingClassGroupModifiers } = config;
	function getClassGroupId(className) {
		const classParts = className.split(CLASS_PART_SEPARATOR);
		if (classParts[0] === "" && classParts.length !== 1) classParts.shift();
		return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
	}
	function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
		const conflicts = conflictingClassGroups[classGroupId] || [];
		if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
		return conflicts;
	}
	return {
		getClassGroupId,
		getConflictingClassGroupIds
	};
}
function getGroupRecursive(classParts, classPartObject) {
	if (classParts.length === 0) return classPartObject.classGroupId;
	const currentClassPart = classParts[0];
	const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
	const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
	if (classGroupFromNextClassPart) return classGroupFromNextClassPart;
	if (classPartObject.validators.length === 0) return;
	const classRest = classParts.join(CLASS_PART_SEPARATOR);
	return classPartObject.validators.find(({ validator }) => validator(classRest))?.classGroupId;
}
var arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(className) {
	if (arbitraryPropertyRegex.test(className)) {
		const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
		const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(":"));
		if (property) return "arbitrary.." + property;
	}
}
/**
* Exported for testing only
*/
function createClassMap(config) {
	const { theme, prefix } = config;
	const classMap = {
		nextPart: /* @__PURE__ */ new Map(),
		validators: []
	};
	getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix).forEach(([classGroupId, classGroup]) => {
		processClassesRecursively(classGroup, classMap, classGroupId, theme);
	});
	return classMap;
}
function processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
	classGroup.forEach((classDefinition) => {
		if (typeof classDefinition === "string") {
			const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
			classPartObjectToEdit.classGroupId = classGroupId;
			return;
		}
		if (typeof classDefinition === "function") {
			if (isThemeGetter(classDefinition)) {
				processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
				return;
			}
			classPartObject.validators.push({
				validator: classDefinition,
				classGroupId
			});
			return;
		}
		Object.entries(classDefinition).forEach(([key, classGroup]) => {
			processClassesRecursively(classGroup, getPart(classPartObject, key), classGroupId, theme);
		});
	});
}
function getPart(classPartObject, path) {
	let currentClassPartObject = classPartObject;
	path.split(CLASS_PART_SEPARATOR).forEach((pathPart) => {
		if (!currentClassPartObject.nextPart.has(pathPart)) currentClassPartObject.nextPart.set(pathPart, {
			nextPart: /* @__PURE__ */ new Map(),
			validators: []
		});
		currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
	});
	return currentClassPartObject;
}
function isThemeGetter(func) {
	return func.isThemeGetter;
}
function getPrefixedClassGroupEntries(classGroupEntries, prefix) {
	if (!prefix) return classGroupEntries;
	return classGroupEntries.map(([classGroupId, classGroup]) => {
		return [classGroupId, classGroup.map((classDefinition) => {
			if (typeof classDefinition === "string") return prefix + classDefinition;
			if (typeof classDefinition === "object") return Object.fromEntries(Object.entries(classDefinition).map(([key, value]) => [prefix + key, value]));
			return classDefinition;
		})];
	});
}
function createLruCache(maxCacheSize) {
	if (maxCacheSize < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let cacheSize = 0;
	let cache = /* @__PURE__ */ new Map();
	let previousCache = /* @__PURE__ */ new Map();
	function update(key, value) {
		cache.set(key, value);
		cacheSize++;
		if (cacheSize > maxCacheSize) {
			cacheSize = 0;
			previousCache = cache;
			cache = /* @__PURE__ */ new Map();
		}
	}
	return {
		get(key) {
			let value = cache.get(key);
			if (value !== void 0) return value;
			if ((value = previousCache.get(key)) !== void 0) {
				update(key, value);
				return value;
			}
		},
		set(key, value) {
			if (cache.has(key)) cache.set(key, value);
			else update(key, value);
		}
	};
}
var IMPORTANT_MODIFIER = "!";
function createSplitModifiers(config) {
	const separator = config.separator;
	const isSeparatorSingleCharacter = separator.length === 1;
	const firstSeparatorCharacter = separator[0];
	const separatorLength = separator.length;
	return function splitModifiers(className) {
		const modifiers = [];
		let bracketDepth = 0;
		let modifierStart = 0;
		let postfixModifierPosition;
		for (let index = 0; index < className.length; index++) {
			let currentCharacter = className[index];
			if (bracketDepth === 0) {
				if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
					modifiers.push(className.slice(modifierStart, index));
					modifierStart = index + separatorLength;
					continue;
				}
				if (currentCharacter === "/") {
					postfixModifierPosition = index;
					continue;
				}
			}
			if (currentCharacter === "[") bracketDepth++;
			else if (currentCharacter === "]") bracketDepth--;
		}
		const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
		const hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
		return {
			modifiers,
			hasImportantModifier,
			baseClassName: hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier,
			maybePostfixModifierPosition: postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0
		};
	};
}
/**
* Sorts modifiers according to following schema:
* - Predefined modifiers are sorted alphabetically
* - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
*/
function sortModifiers(modifiers) {
	if (modifiers.length <= 1) return modifiers;
	const sortedModifiers = [];
	let unsortedModifiers = [];
	modifiers.forEach((modifier) => {
		if (modifier[0] === "[") {
			sortedModifiers.push(...unsortedModifiers.sort(), modifier);
			unsortedModifiers = [];
		} else unsortedModifiers.push(modifier);
	});
	sortedModifiers.push(...unsortedModifiers.sort());
	return sortedModifiers;
}
function createConfigUtils(config) {
	return {
		cache: createLruCache(config.cacheSize),
		splitModifiers: createSplitModifiers(config),
		...createClassUtils(config)
	};
}
var SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(classList, configUtils) {
	const { splitModifiers, getClassGroupId, getConflictingClassGroupIds } = configUtils;
	/**
	* Set of classGroupIds in following format:
	* `{importantModifier}{variantModifiers}{classGroupId}`
	* @example 'float'
	* @example 'hover:focus:bg-color'
	* @example 'md:!pr'
	*/
	const classGroupsInConflict = /* @__PURE__ */ new Set();
	return classList.trim().split(SPLIT_CLASSES_REGEX).map((originalClassName) => {
		const { modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition } = splitModifiers(originalClassName);
		let classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
		let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
		if (!classGroupId) {
			if (!maybePostfixModifierPosition) return {
				isTailwindClass: false,
				originalClassName
			};
			classGroupId = getClassGroupId(baseClassName);
			if (!classGroupId) return {
				isTailwindClass: false,
				originalClassName
			};
			hasPostfixModifier = false;
		}
		const variantModifier = sortModifiers(modifiers).join(":");
		return {
			isTailwindClass: true,
			modifierId: hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier,
			classGroupId,
			originalClassName,
			hasPostfixModifier
		};
	}).reverse().filter((parsed) => {
		if (!parsed.isTailwindClass) return true;
		const { modifierId, classGroupId, hasPostfixModifier } = parsed;
		const classId = modifierId + classGroupId;
		if (classGroupsInConflict.has(classId)) return false;
		classGroupsInConflict.add(classId);
		getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach((group) => classGroupsInConflict.add(modifierId + group));
		return true;
	}).reverse().map((parsed) => parsed.originalClassName).join(" ");
}
/**
* The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
*
* Specifically:
* - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
* - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
*
* Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
*/
function twJoin() {
	let index = 0;
	let argument;
	let resolvedValue;
	let string = "";
	while (index < arguments.length) if (argument = arguments[index++]) {
		if (resolvedValue = toValue(argument)) {
			string && (string += " ");
			string += resolvedValue;
		}
	}
	return string;
}
function toValue(mix) {
	if (typeof mix === "string") return mix;
	let resolvedValue;
	let string = "";
	for (let k = 0; k < mix.length; k++) if (mix[k]) {
		if (resolvedValue = toValue(mix[k])) {
			string && (string += " ");
			string += resolvedValue;
		}
	}
	return string;
}
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
	let configUtils;
	let cacheGet;
	let cacheSet;
	let functionToCall = initTailwindMerge;
	function initTailwindMerge(classList) {
		configUtils = createConfigUtils(createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst()));
		cacheGet = configUtils.cache.get;
		cacheSet = configUtils.cache.set;
		functionToCall = tailwindMerge;
		return tailwindMerge(classList);
	}
	function tailwindMerge(classList) {
		const cachedResult = cacheGet(classList);
		if (cachedResult) return cachedResult;
		const result = mergeClassList(classList, configUtils);
		cacheSet(classList, result);
		return result;
	}
	return function callTailwindMerge() {
		return functionToCall(twJoin.apply(null, arguments));
	};
}
function fromTheme(key) {
	const themeGetter = (theme) => theme[key] || [];
	themeGetter.isThemeGetter = true;
	return themeGetter;
}
var arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
var fractionRegex = /^\d+\/\d+$/;
var stringLengths = /*#__PURE__*/ new Set([
	"px",
	"full",
	"screen"
]);
var tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
var colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
var shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
var imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function isLength(value) {
	return isNumber(value) || stringLengths.has(value) || fractionRegex.test(value);
}
function isArbitraryLength(value) {
	return getIsArbitraryValue(value, "length", isLengthOnly);
}
function isNumber(value) {
	return Boolean(value) && !Number.isNaN(Number(value));
}
function isArbitraryNumber(value) {
	return getIsArbitraryValue(value, "number", isNumber);
}
function isInteger(value) {
	return Boolean(value) && Number.isInteger(Number(value));
}
function isPercent(value) {
	return value.endsWith("%") && isNumber(value.slice(0, -1));
}
function isArbitraryValue(value) {
	return arbitraryValueRegex.test(value);
}
function isTshirtSize(value) {
	return tshirtUnitRegex.test(value);
}
var sizeLabels = /*#__PURE__*/ new Set([
	"length",
	"size",
	"percentage"
]);
function isArbitrarySize(value) {
	return getIsArbitraryValue(value, sizeLabels, isNever);
}
function isArbitraryPosition(value) {
	return getIsArbitraryValue(value, "position", isNever);
}
var imageLabels = /*#__PURE__*/ new Set(["image", "url"]);
function isArbitraryImage(value) {
	return getIsArbitraryValue(value, imageLabels, isImage);
}
function isArbitraryShadow(value) {
	return getIsArbitraryValue(value, "", isShadow);
}
function isAny() {
	return true;
}
function getIsArbitraryValue(value, label, testValue) {
	const result = arbitraryValueRegex.exec(value);
	if (result) {
		if (result[1]) return typeof label === "string" ? result[1] === label : label.has(result[1]);
		return testValue(result[2]);
	}
	return false;
}
function isLengthOnly(value) {
	return lengthUnitRegex.test(value) && !colorFunctionRegex.test(value);
}
function isNever() {
	return false;
}
function isShadow(value) {
	return shadowRegex.test(value);
}
function isImage(value) {
	return imageRegex.test(value);
}
function getDefaultConfig() {
	const colors = fromTheme("colors");
	const spacing = fromTheme("spacing");
	const blur = fromTheme("blur");
	const brightness = fromTheme("brightness");
	const borderColor = fromTheme("borderColor");
	const borderRadius = fromTheme("borderRadius");
	const borderSpacing = fromTheme("borderSpacing");
	const borderWidth = fromTheme("borderWidth");
	const contrast = fromTheme("contrast");
	const grayscale = fromTheme("grayscale");
	const hueRotate = fromTheme("hueRotate");
	const invert = fromTheme("invert");
	const gap = fromTheme("gap");
	const gradientColorStops = fromTheme("gradientColorStops");
	const gradientColorStopPositions = fromTheme("gradientColorStopPositions");
	const inset = fromTheme("inset");
	const margin = fromTheme("margin");
	const opacity = fromTheme("opacity");
	const padding = fromTheme("padding");
	const saturate = fromTheme("saturate");
	const scale = fromTheme("scale");
	const sepia = fromTheme("sepia");
	const skew = fromTheme("skew");
	const space = fromTheme("space");
	const translate = fromTheme("translate");
	const getOverscroll = () => [
		"auto",
		"contain",
		"none"
	];
	const getOverflow = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	];
	const getSpacingWithAutoAndArbitrary = () => [
		"auto",
		isArbitraryValue,
		spacing
	];
	const getSpacingWithArbitrary = () => [isArbitraryValue, spacing];
	const getLengthWithEmptyAndArbitrary = () => [
		"",
		isLength,
		isArbitraryLength
	];
	const getNumberWithAutoAndArbitrary = () => [
		"auto",
		isNumber,
		isArbitraryValue
	];
	const getPositions = () => [
		"bottom",
		"center",
		"left",
		"left-bottom",
		"left-top",
		"right",
		"right-bottom",
		"right-top",
		"top"
	];
	const getLineStyles = () => [
		"solid",
		"dashed",
		"dotted",
		"double",
		"none"
	];
	const getBlendModes = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	];
	const getAlign = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch"
	];
	const getZeroAndEmpty = () => [
		"",
		"0",
		isArbitraryValue
	];
	const getBreaks = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	];
	const getNumber = () => [isNumber, isArbitraryNumber];
	const getNumberAndArbitrary = () => [isNumber, isArbitraryValue];
	return {
		cacheSize: 500,
		separator: ":",
		theme: {
			colors: [isAny],
			spacing: [isLength, isArbitraryLength],
			blur: [
				"none",
				"",
				isTshirtSize,
				isArbitraryValue
			],
			brightness: getNumber(),
			borderColor: [colors],
			borderRadius: [
				"none",
				"",
				"full",
				isTshirtSize,
				isArbitraryValue
			],
			borderSpacing: getSpacingWithArbitrary(),
			borderWidth: getLengthWithEmptyAndArbitrary(),
			contrast: getNumber(),
			grayscale: getZeroAndEmpty(),
			hueRotate: getNumberAndArbitrary(),
			invert: getZeroAndEmpty(),
			gap: getSpacingWithArbitrary(),
			gradientColorStops: [colors],
			gradientColorStopPositions: [isPercent, isArbitraryLength],
			inset: getSpacingWithAutoAndArbitrary(),
			margin: getSpacingWithAutoAndArbitrary(),
			opacity: getNumber(),
			padding: getSpacingWithArbitrary(),
			saturate: getNumber(),
			scale: getNumber(),
			sepia: getZeroAndEmpty(),
			skew: getNumberAndArbitrary(),
			space: getSpacingWithArbitrary(),
			translate: getSpacingWithArbitrary()
		},
		classGroups: {
			/**
			* Aspect Ratio
			* @see https://tailwindcss.com/docs/aspect-ratio
			*/
			aspect: [{ aspect: [
				"auto",
				"square",
				"video",
				isArbitraryValue
			] }],
			/**
			* Container
			* @see https://tailwindcss.com/docs/container
			*/
			container: ["container"],
			/**
			* Columns
			* @see https://tailwindcss.com/docs/columns
			*/
			columns: [{ columns: [isTshirtSize] }],
			/**
			* Break After
			* @see https://tailwindcss.com/docs/break-after
			*/
			"break-after": [{ "break-after": getBreaks() }],
			/**
			* Break Before
			* @see https://tailwindcss.com/docs/break-before
			*/
			"break-before": [{ "break-before": getBreaks() }],
			/**
			* Break Inside
			* @see https://tailwindcss.com/docs/break-inside
			*/
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			/**
			* Box Decoration Break
			* @see https://tailwindcss.com/docs/box-decoration-break
			*/
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			/**
			* Box Sizing
			* @see https://tailwindcss.com/docs/box-sizing
			*/
			box: [{ box: ["border", "content"] }],
			/**
			* Display
			* @see https://tailwindcss.com/docs/display
			*/
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			/**
			* Floats
			* @see https://tailwindcss.com/docs/float
			*/
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			/**
			* Clear
			* @see https://tailwindcss.com/docs/clear
			*/
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			/**
			* Isolation
			* @see https://tailwindcss.com/docs/isolation
			*/
			isolation: ["isolate", "isolation-auto"],
			/**
			* Object Fit
			* @see https://tailwindcss.com/docs/object-fit
			*/
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			/**
			* Object Position
			* @see https://tailwindcss.com/docs/object-position
			*/
			"object-position": [{ object: [...getPositions(), isArbitraryValue] }],
			/**
			* Overflow
			* @see https://tailwindcss.com/docs/overflow
			*/
			overflow: [{ overflow: getOverflow() }],
			/**
			* Overflow X
			* @see https://tailwindcss.com/docs/overflow
			*/
			"overflow-x": [{ "overflow-x": getOverflow() }],
			/**
			* Overflow Y
			* @see https://tailwindcss.com/docs/overflow
			*/
			"overflow-y": [{ "overflow-y": getOverflow() }],
			/**
			* Overscroll Behavior
			* @see https://tailwindcss.com/docs/overscroll-behavior
			*/
			overscroll: [{ overscroll: getOverscroll() }],
			/**
			* Overscroll Behavior X
			* @see https://tailwindcss.com/docs/overscroll-behavior
			*/
			"overscroll-x": [{ "overscroll-x": getOverscroll() }],
			/**
			* Overscroll Behavior Y
			* @see https://tailwindcss.com/docs/overscroll-behavior
			*/
			"overscroll-y": [{ "overscroll-y": getOverscroll() }],
			/**
			* Position
			* @see https://tailwindcss.com/docs/position
			*/
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			/**
			* Top / Right / Bottom / Left
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/
			inset: [{ inset: [inset] }],
			/**
			* Right / Left
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/
			"inset-x": [{ "inset-x": [inset] }],
			/**
			* Top / Bottom
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/
			"inset-y": [{ "inset-y": [inset] }],
			/**
			* Start
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/
			start: [{ start: [inset] }],
			/**
			* End
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/
			end: [{ end: [inset] }],
			/**
			* Top
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/
			top: [{ top: [inset] }],
			/**
			* Right
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/
			right: [{ right: [inset] }],
			/**
			* Bottom
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/
			bottom: [{ bottom: [inset] }],
			/**
			* Left
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/
			left: [{ left: [inset] }],
			/**
			* Visibility
			* @see https://tailwindcss.com/docs/visibility
			*/
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			/**
			* Z-Index
			* @see https://tailwindcss.com/docs/z-index
			*/
			z: [{ z: [
				"auto",
				isInteger,
				isArbitraryValue
			] }],
			/**
			* Flex Basis
			* @see https://tailwindcss.com/docs/flex-basis
			*/
			basis: [{ basis: getSpacingWithAutoAndArbitrary() }],
			/**
			* Flex Direction
			* @see https://tailwindcss.com/docs/flex-direction
			*/
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			/**
			* Flex Wrap
			* @see https://tailwindcss.com/docs/flex-wrap
			*/
			"flex-wrap": [{ flex: [
				"wrap",
				"wrap-reverse",
				"nowrap"
			] }],
			/**
			* Flex
			* @see https://tailwindcss.com/docs/flex
			*/
			flex: [{ flex: [
				"1",
				"auto",
				"initial",
				"none",
				isArbitraryValue
			] }],
			/**
			* Flex Grow
			* @see https://tailwindcss.com/docs/flex-grow
			*/
			grow: [{ grow: getZeroAndEmpty() }],
			/**
			* Flex Shrink
			* @see https://tailwindcss.com/docs/flex-shrink
			*/
			shrink: [{ shrink: getZeroAndEmpty() }],
			/**
			* Order
			* @see https://tailwindcss.com/docs/order
			*/
			order: [{ order: [
				"first",
				"last",
				"none",
				isInteger,
				isArbitraryValue
			] }],
			/**
			* Grid Template Columns
			* @see https://tailwindcss.com/docs/grid-template-columns
			*/
			"grid-cols": [{ "grid-cols": [isAny] }],
			/**
			* Grid Column Start / End
			* @see https://tailwindcss.com/docs/grid-column
			*/
			"col-start-end": [{ col: [
				"auto",
				{ span: [
					"full",
					isInteger,
					isArbitraryValue
				] },
				isArbitraryValue
			] }],
			/**
			* Grid Column Start
			* @see https://tailwindcss.com/docs/grid-column
			*/
			"col-start": [{ "col-start": getNumberWithAutoAndArbitrary() }],
			/**
			* Grid Column End
			* @see https://tailwindcss.com/docs/grid-column
			*/
			"col-end": [{ "col-end": getNumberWithAutoAndArbitrary() }],
			/**
			* Grid Template Rows
			* @see https://tailwindcss.com/docs/grid-template-rows
			*/
			"grid-rows": [{ "grid-rows": [isAny] }],
			/**
			* Grid Row Start / End
			* @see https://tailwindcss.com/docs/grid-row
			*/
			"row-start-end": [{ row: [
				"auto",
				{ span: [isInteger, isArbitraryValue] },
				isArbitraryValue
			] }],
			/**
			* Grid Row Start
			* @see https://tailwindcss.com/docs/grid-row
			*/
			"row-start": [{ "row-start": getNumberWithAutoAndArbitrary() }],
			/**
			* Grid Row End
			* @see https://tailwindcss.com/docs/grid-row
			*/
			"row-end": [{ "row-end": getNumberWithAutoAndArbitrary() }],
			/**
			* Grid Auto Flow
			* @see https://tailwindcss.com/docs/grid-auto-flow
			*/
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			/**
			* Grid Auto Columns
			* @see https://tailwindcss.com/docs/grid-auto-columns
			*/
			"auto-cols": [{ "auto-cols": [
				"auto",
				"min",
				"max",
				"fr",
				isArbitraryValue
			] }],
			/**
			* Grid Auto Rows
			* @see https://tailwindcss.com/docs/grid-auto-rows
			*/
			"auto-rows": [{ "auto-rows": [
				"auto",
				"min",
				"max",
				"fr",
				isArbitraryValue
			] }],
			/**
			* Gap
			* @see https://tailwindcss.com/docs/gap
			*/
			gap: [{ gap: [gap] }],
			/**
			* Gap X
			* @see https://tailwindcss.com/docs/gap
			*/
			"gap-x": [{ "gap-x": [gap] }],
			/**
			* Gap Y
			* @see https://tailwindcss.com/docs/gap
			*/
			"gap-y": [{ "gap-y": [gap] }],
			/**
			* Justify Content
			* @see https://tailwindcss.com/docs/justify-content
			*/
			"justify-content": [{ justify: ["normal", ...getAlign()] }],
			/**
			* Justify Items
			* @see https://tailwindcss.com/docs/justify-items
			*/
			"justify-items": [{ "justify-items": [
				"start",
				"end",
				"center",
				"stretch"
			] }],
			/**
			* Justify Self
			* @see https://tailwindcss.com/docs/justify-self
			*/
			"justify-self": [{ "justify-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			/**
			* Align Content
			* @see https://tailwindcss.com/docs/align-content
			*/
			"align-content": [{ content: [
				"normal",
				...getAlign(),
				"baseline"
			] }],
			/**
			* Align Items
			* @see https://tailwindcss.com/docs/align-items
			*/
			"align-items": [{ items: [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			/**
			* Align Self
			* @see https://tailwindcss.com/docs/align-self
			*/
			"align-self": [{ self: [
				"auto",
				"start",
				"end",
				"center",
				"stretch",
				"baseline"
			] }],
			/**
			* Place Content
			* @see https://tailwindcss.com/docs/place-content
			*/
			"place-content": [{ "place-content": [...getAlign(), "baseline"] }],
			/**
			* Place Items
			* @see https://tailwindcss.com/docs/place-items
			*/
			"place-items": [{ "place-items": [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			/**
			* Place Self
			* @see https://tailwindcss.com/docs/place-self
			*/
			"place-self": [{ "place-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			/**
			* Padding
			* @see https://tailwindcss.com/docs/padding
			*/
			p: [{ p: [padding] }],
			/**
			* Padding X
			* @see https://tailwindcss.com/docs/padding
			*/
			px: [{ px: [padding] }],
			/**
			* Padding Y
			* @see https://tailwindcss.com/docs/padding
			*/
			py: [{ py: [padding] }],
			/**
			* Padding Start
			* @see https://tailwindcss.com/docs/padding
			*/
			ps: [{ ps: [padding] }],
			/**
			* Padding End
			* @see https://tailwindcss.com/docs/padding
			*/
			pe: [{ pe: [padding] }],
			/**
			* Padding Top
			* @see https://tailwindcss.com/docs/padding
			*/
			pt: [{ pt: [padding] }],
			/**
			* Padding Right
			* @see https://tailwindcss.com/docs/padding
			*/
			pr: [{ pr: [padding] }],
			/**
			* Padding Bottom
			* @see https://tailwindcss.com/docs/padding
			*/
			pb: [{ pb: [padding] }],
			/**
			* Padding Left
			* @see https://tailwindcss.com/docs/padding
			*/
			pl: [{ pl: [padding] }],
			/**
			* Margin
			* @see https://tailwindcss.com/docs/margin
			*/
			m: [{ m: [margin] }],
			/**
			* Margin X
			* @see https://tailwindcss.com/docs/margin
			*/
			mx: [{ mx: [margin] }],
			/**
			* Margin Y
			* @see https://tailwindcss.com/docs/margin
			*/
			my: [{ my: [margin] }],
			/**
			* Margin Start
			* @see https://tailwindcss.com/docs/margin
			*/
			ms: [{ ms: [margin] }],
			/**
			* Margin End
			* @see https://tailwindcss.com/docs/margin
			*/
			me: [{ me: [margin] }],
			/**
			* Margin Top
			* @see https://tailwindcss.com/docs/margin
			*/
			mt: [{ mt: [margin] }],
			/**
			* Margin Right
			* @see https://tailwindcss.com/docs/margin
			*/
			mr: [{ mr: [margin] }],
			/**
			* Margin Bottom
			* @see https://tailwindcss.com/docs/margin
			*/
			mb: [{ mb: [margin] }],
			/**
			* Margin Left
			* @see https://tailwindcss.com/docs/margin
			*/
			ml: [{ ml: [margin] }],
			/**
			* Space Between X
			* @see https://tailwindcss.com/docs/space
			*/
			"space-x": [{ "space-x": [space] }],
			/**
			* Space Between X Reverse
			* @see https://tailwindcss.com/docs/space
			*/
			"space-x-reverse": ["space-x-reverse"],
			/**
			* Space Between Y
			* @see https://tailwindcss.com/docs/space
			*/
			"space-y": [{ "space-y": [space] }],
			/**
			* Space Between Y Reverse
			* @see https://tailwindcss.com/docs/space
			*/
			"space-y-reverse": ["space-y-reverse"],
			/**
			* Width
			* @see https://tailwindcss.com/docs/width
			*/
			w: [{ w: [
				"auto",
				"min",
				"max",
				"fit",
				"svw",
				"lvw",
				"dvw",
				isArbitraryValue,
				spacing
			] }],
			/**
			* Min-Width
			* @see https://tailwindcss.com/docs/min-width
			*/
			"min-w": [{ "min-w": [
				isArbitraryValue,
				spacing,
				"min",
				"max",
				"fit"
			] }],
			/**
			* Max-Width
			* @see https://tailwindcss.com/docs/max-width
			*/
			"max-w": [{ "max-w": [
				isArbitraryValue,
				spacing,
				"none",
				"full",
				"min",
				"max",
				"fit",
				"prose",
				{ screen: [isTshirtSize] },
				isTshirtSize
			] }],
			/**
			* Height
			* @see https://tailwindcss.com/docs/height
			*/
			h: [{ h: [
				isArbitraryValue,
				spacing,
				"auto",
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			/**
			* Min-Height
			* @see https://tailwindcss.com/docs/min-height
			*/
			"min-h": [{ "min-h": [
				isArbitraryValue,
				spacing,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			/**
			* Max-Height
			* @see https://tailwindcss.com/docs/max-height
			*/
			"max-h": [{ "max-h": [
				isArbitraryValue,
				spacing,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			/**
			* Size
			* @see https://tailwindcss.com/docs/size
			*/
			size: [{ size: [
				isArbitraryValue,
				spacing,
				"auto",
				"min",
				"max",
				"fit"
			] }],
			/**
			* Font Size
			* @see https://tailwindcss.com/docs/font-size
			*/
			"font-size": [{ text: [
				"base",
				isTshirtSize,
				isArbitraryLength
			] }],
			/**
			* Font Smoothing
			* @see https://tailwindcss.com/docs/font-smoothing
			*/
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			/**
			* Font Style
			* @see https://tailwindcss.com/docs/font-style
			*/
			"font-style": ["italic", "not-italic"],
			/**
			* Font Weight
			* @see https://tailwindcss.com/docs/font-weight
			*/
			"font-weight": [{ font: [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black",
				isArbitraryNumber
			] }],
			/**
			* Font Family
			* @see https://tailwindcss.com/docs/font-family
			*/
			"font-family": [{ font: [isAny] }],
			/**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/
			"fvn-normal": ["normal-nums"],
			/**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/
			"fvn-ordinal": ["ordinal"],
			/**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/
			"fvn-slashed-zero": ["slashed-zero"],
			/**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			/**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			/**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/
			"fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
			/**
			* Letter Spacing
			* @see https://tailwindcss.com/docs/letter-spacing
			*/
			tracking: [{ tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest",
				isArbitraryValue
			] }],
			/**
			* Line Clamp
			* @see https://tailwindcss.com/docs/line-clamp
			*/
			"line-clamp": [{ "line-clamp": [
				"none",
				isNumber,
				isArbitraryNumber
			] }],
			/**
			* Line Height
			* @see https://tailwindcss.com/docs/line-height
			*/
			leading: [{ leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose",
				isLength,
				isArbitraryValue
			] }],
			/**
			* List Style Image
			* @see https://tailwindcss.com/docs/list-style-image
			*/
			"list-image": [{ "list-image": ["none", isArbitraryValue] }],
			/**
			* List Style Type
			* @see https://tailwindcss.com/docs/list-style-type
			*/
			"list-style-type": [{ list: [
				"none",
				"disc",
				"decimal",
				isArbitraryValue
			] }],
			/**
			* List Style Position
			* @see https://tailwindcss.com/docs/list-style-position
			*/
			"list-style-position": [{ list: ["inside", "outside"] }],
			/**
			* Placeholder Color
			* @deprecated since Tailwind CSS v3.0.0
			* @see https://tailwindcss.com/docs/placeholder-color
			*/
			"placeholder-color": [{ placeholder: [colors] }],
			/**
			* Placeholder Opacity
			* @see https://tailwindcss.com/docs/placeholder-opacity
			*/
			"placeholder-opacity": [{ "placeholder-opacity": [opacity] }],
			/**
			* Text Alignment
			* @see https://tailwindcss.com/docs/text-align
			*/
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			/**
			* Text Color
			* @see https://tailwindcss.com/docs/text-color
			*/
			"text-color": [{ text: [colors] }],
			/**
			* Text Opacity
			* @see https://tailwindcss.com/docs/text-opacity
			*/
			"text-opacity": [{ "text-opacity": [opacity] }],
			/**
			* Text Decoration
			* @see https://tailwindcss.com/docs/text-decoration
			*/
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			/**
			* Text Decoration Style
			* @see https://tailwindcss.com/docs/text-decoration-style
			*/
			"text-decoration-style": [{ decoration: [...getLineStyles(), "wavy"] }],
			/**
			* Text Decoration Thickness
			* @see https://tailwindcss.com/docs/text-decoration-thickness
			*/
			"text-decoration-thickness": [{ decoration: [
				"auto",
				"from-font",
				isLength,
				isArbitraryLength
			] }],
			/**
			* Text Underline Offset
			* @see https://tailwindcss.com/docs/text-underline-offset
			*/
			"underline-offset": [{ "underline-offset": [
				"auto",
				isLength,
				isArbitraryValue
			] }],
			/**
			* Text Decoration Color
			* @see https://tailwindcss.com/docs/text-decoration-color
			*/
			"text-decoration-color": [{ decoration: [colors] }],
			/**
			* Text Transform
			* @see https://tailwindcss.com/docs/text-transform
			*/
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			/**
			* Text Overflow
			* @see https://tailwindcss.com/docs/text-overflow
			*/
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			/**
			* Text Wrap
			* @see https://tailwindcss.com/docs/text-wrap
			*/
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			/**
			* Text Indent
			* @see https://tailwindcss.com/docs/text-indent
			*/
			indent: [{ indent: getSpacingWithArbitrary() }],
			/**
			* Vertical Alignment
			* @see https://tailwindcss.com/docs/vertical-align
			*/
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				isArbitraryValue
			] }],
			/**
			* Whitespace
			* @see https://tailwindcss.com/docs/whitespace
			*/
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			/**
			* Word Break
			* @see https://tailwindcss.com/docs/word-break
			*/
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			/**
			* Hyphens
			* @see https://tailwindcss.com/docs/hyphens
			*/
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			/**
			* Content
			* @see https://tailwindcss.com/docs/content
			*/
			content: [{ content: ["none", isArbitraryValue] }],
			/**
			* Background Attachment
			* @see https://tailwindcss.com/docs/background-attachment
			*/
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			/**
			* Background Clip
			* @see https://tailwindcss.com/docs/background-clip
			*/
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			/**
			* Background Opacity
			* @deprecated since Tailwind CSS v3.0.0
			* @see https://tailwindcss.com/docs/background-opacity
			*/
			"bg-opacity": [{ "bg-opacity": [opacity] }],
			/**
			* Background Origin
			* @see https://tailwindcss.com/docs/background-origin
			*/
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			/**
			* Background Position
			* @see https://tailwindcss.com/docs/background-position
			*/
			"bg-position": [{ bg: [...getPositions(), isArbitraryPosition] }],
			/**
			* Background Repeat
			* @see https://tailwindcss.com/docs/background-repeat
			*/
			"bg-repeat": [{ bg: ["no-repeat", { repeat: [
				"",
				"x",
				"y",
				"round",
				"space"
			] }] }],
			/**
			* Background Size
			* @see https://tailwindcss.com/docs/background-size
			*/
			"bg-size": [{ bg: [
				"auto",
				"cover",
				"contain",
				isArbitrarySize
			] }],
			/**
			* Background Image
			* @see https://tailwindcss.com/docs/background-image
			*/
			"bg-image": [{ bg: [
				"none",
				{ "gradient-to": [
					"t",
					"tr",
					"r",
					"br",
					"b",
					"bl",
					"l",
					"tl"
				] },
				isArbitraryImage
			] }],
			/**
			* Background Color
			* @see https://tailwindcss.com/docs/background-color
			*/
			"bg-color": [{ bg: [colors] }],
			/**
			* Gradient Color Stops From Position
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/
			"gradient-from-pos": [{ from: [gradientColorStopPositions] }],
			/**
			* Gradient Color Stops Via Position
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/
			"gradient-via-pos": [{ via: [gradientColorStopPositions] }],
			/**
			* Gradient Color Stops To Position
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/
			"gradient-to-pos": [{ to: [gradientColorStopPositions] }],
			/**
			* Gradient Color Stops From
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/
			"gradient-from": [{ from: [gradientColorStops] }],
			/**
			* Gradient Color Stops Via
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/
			"gradient-via": [{ via: [gradientColorStops] }],
			/**
			* Gradient Color Stops To
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/
			"gradient-to": [{ to: [gradientColorStops] }],
			/**
			* Border Radius
			* @see https://tailwindcss.com/docs/border-radius
			*/
			rounded: [{ rounded: [borderRadius] }],
			/**
			* Border Radius Start
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-s": [{ "rounded-s": [borderRadius] }],
			/**
			* Border Radius End
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-e": [{ "rounded-e": [borderRadius] }],
			/**
			* Border Radius Top
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-t": [{ "rounded-t": [borderRadius] }],
			/**
			* Border Radius Right
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-r": [{ "rounded-r": [borderRadius] }],
			/**
			* Border Radius Bottom
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-b": [{ "rounded-b": [borderRadius] }],
			/**
			* Border Radius Left
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-l": [{ "rounded-l": [borderRadius] }],
			/**
			* Border Radius Start Start
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-ss": [{ "rounded-ss": [borderRadius] }],
			/**
			* Border Radius Start End
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-se": [{ "rounded-se": [borderRadius] }],
			/**
			* Border Radius End End
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-ee": [{ "rounded-ee": [borderRadius] }],
			/**
			* Border Radius End Start
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-es": [{ "rounded-es": [borderRadius] }],
			/**
			* Border Radius Top Left
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-tl": [{ "rounded-tl": [borderRadius] }],
			/**
			* Border Radius Top Right
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-tr": [{ "rounded-tr": [borderRadius] }],
			/**
			* Border Radius Bottom Right
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-br": [{ "rounded-br": [borderRadius] }],
			/**
			* Border Radius Bottom Left
			* @see https://tailwindcss.com/docs/border-radius
			*/
			"rounded-bl": [{ "rounded-bl": [borderRadius] }],
			/**
			* Border Width
			* @see https://tailwindcss.com/docs/border-width
			*/
			"border-w": [{ border: [borderWidth] }],
			/**
			* Border Width X
			* @see https://tailwindcss.com/docs/border-width
			*/
			"border-w-x": [{ "border-x": [borderWidth] }],
			/**
			* Border Width Y
			* @see https://tailwindcss.com/docs/border-width
			*/
			"border-w-y": [{ "border-y": [borderWidth] }],
			/**
			* Border Width Start
			* @see https://tailwindcss.com/docs/border-width
			*/
			"border-w-s": [{ "border-s": [borderWidth] }],
			/**
			* Border Width End
			* @see https://tailwindcss.com/docs/border-width
			*/
			"border-w-e": [{ "border-e": [borderWidth] }],
			/**
			* Border Width Top
			* @see https://tailwindcss.com/docs/border-width
			*/
			"border-w-t": [{ "border-t": [borderWidth] }],
			/**
			* Border Width Right
			* @see https://tailwindcss.com/docs/border-width
			*/
			"border-w-r": [{ "border-r": [borderWidth] }],
			/**
			* Border Width Bottom
			* @see https://tailwindcss.com/docs/border-width
			*/
			"border-w-b": [{ "border-b": [borderWidth] }],
			/**
			* Border Width Left
			* @see https://tailwindcss.com/docs/border-width
			*/
			"border-w-l": [{ "border-l": [borderWidth] }],
			/**
			* Border Opacity
			* @see https://tailwindcss.com/docs/border-opacity
			*/
			"border-opacity": [{ "border-opacity": [opacity] }],
			/**
			* Border Style
			* @see https://tailwindcss.com/docs/border-style
			*/
			"border-style": [{ border: [...getLineStyles(), "hidden"] }],
			/**
			* Divide Width X
			* @see https://tailwindcss.com/docs/divide-width
			*/
			"divide-x": [{ "divide-x": [borderWidth] }],
			/**
			* Divide Width X Reverse
			* @see https://tailwindcss.com/docs/divide-width
			*/
			"divide-x-reverse": ["divide-x-reverse"],
			/**
			* Divide Width Y
			* @see https://tailwindcss.com/docs/divide-width
			*/
			"divide-y": [{ "divide-y": [borderWidth] }],
			/**
			* Divide Width Y Reverse
			* @see https://tailwindcss.com/docs/divide-width
			*/
			"divide-y-reverse": ["divide-y-reverse"],
			/**
			* Divide Opacity
			* @see https://tailwindcss.com/docs/divide-opacity
			*/
			"divide-opacity": [{ "divide-opacity": [opacity] }],
			/**
			* Divide Style
			* @see https://tailwindcss.com/docs/divide-style
			*/
			"divide-style": [{ divide: getLineStyles() }],
			/**
			* Border Color
			* @see https://tailwindcss.com/docs/border-color
			*/
			"border-color": [{ border: [borderColor] }],
			/**
			* Border Color X
			* @see https://tailwindcss.com/docs/border-color
			*/
			"border-color-x": [{ "border-x": [borderColor] }],
			/**
			* Border Color Y
			* @see https://tailwindcss.com/docs/border-color
			*/
			"border-color-y": [{ "border-y": [borderColor] }],
			/**
			* Border Color Top
			* @see https://tailwindcss.com/docs/border-color
			*/
			"border-color-t": [{ "border-t": [borderColor] }],
			/**
			* Border Color Right
			* @see https://tailwindcss.com/docs/border-color
			*/
			"border-color-r": [{ "border-r": [borderColor] }],
			/**
			* Border Color Bottom
			* @see https://tailwindcss.com/docs/border-color
			*/
			"border-color-b": [{ "border-b": [borderColor] }],
			/**
			* Border Color Left
			* @see https://tailwindcss.com/docs/border-color
			*/
			"border-color-l": [{ "border-l": [borderColor] }],
			/**
			* Divide Color
			* @see https://tailwindcss.com/docs/divide-color
			*/
			"divide-color": [{ divide: [borderColor] }],
			/**
			* Outline Style
			* @see https://tailwindcss.com/docs/outline-style
			*/
			"outline-style": [{ outline: ["", ...getLineStyles()] }],
			/**
			* Outline Offset
			* @see https://tailwindcss.com/docs/outline-offset
			*/
			"outline-offset": [{ "outline-offset": [isLength, isArbitraryValue] }],
			/**
			* Outline Width
			* @see https://tailwindcss.com/docs/outline-width
			*/
			"outline-w": [{ outline: [isLength, isArbitraryLength] }],
			/**
			* Outline Color
			* @see https://tailwindcss.com/docs/outline-color
			*/
			"outline-color": [{ outline: [colors] }],
			/**
			* Ring Width
			* @see https://tailwindcss.com/docs/ring-width
			*/
			"ring-w": [{ ring: getLengthWithEmptyAndArbitrary() }],
			/**
			* Ring Width Inset
			* @see https://tailwindcss.com/docs/ring-width
			*/
			"ring-w-inset": ["ring-inset"],
			/**
			* Ring Color
			* @see https://tailwindcss.com/docs/ring-color
			*/
			"ring-color": [{ ring: [colors] }],
			/**
			* Ring Opacity
			* @see https://tailwindcss.com/docs/ring-opacity
			*/
			"ring-opacity": [{ "ring-opacity": [opacity] }],
			/**
			* Ring Offset Width
			* @see https://tailwindcss.com/docs/ring-offset-width
			*/
			"ring-offset-w": [{ "ring-offset": [isLength, isArbitraryLength] }],
			/**
			* Ring Offset Color
			* @see https://tailwindcss.com/docs/ring-offset-color
			*/
			"ring-offset-color": [{ "ring-offset": [colors] }],
			/**
			* Box Shadow
			* @see https://tailwindcss.com/docs/box-shadow
			*/
			shadow: [{ shadow: [
				"",
				"inner",
				"none",
				isTshirtSize,
				isArbitraryShadow
			] }],
			/**
			* Box Shadow Color
			* @see https://tailwindcss.com/docs/box-shadow-color
			*/
			"shadow-color": [{ shadow: [isAny] }],
			/**
			* Opacity
			* @see https://tailwindcss.com/docs/opacity
			*/
			opacity: [{ opacity: [opacity] }],
			/**
			* Mix Blend Mode
			* @see https://tailwindcss.com/docs/mix-blend-mode
			*/
			"mix-blend": [{ "mix-blend": [
				...getBlendModes(),
				"plus-lighter",
				"plus-darker"
			] }],
			/**
			* Background Blend Mode
			* @see https://tailwindcss.com/docs/background-blend-mode
			*/
			"bg-blend": [{ "bg-blend": getBlendModes() }],
			/**
			* Filter
			* @deprecated since Tailwind CSS v3.0.0
			* @see https://tailwindcss.com/docs/filter
			*/
			filter: [{ filter: ["", "none"] }],
			/**
			* Blur
			* @see https://tailwindcss.com/docs/blur
			*/
			blur: [{ blur: [blur] }],
			/**
			* Brightness
			* @see https://tailwindcss.com/docs/brightness
			*/
			brightness: [{ brightness: [brightness] }],
			/**
			* Contrast
			* @see https://tailwindcss.com/docs/contrast
			*/
			contrast: [{ contrast: [contrast] }],
			/**
			* Drop Shadow
			* @see https://tailwindcss.com/docs/drop-shadow
			*/
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				isTshirtSize,
				isArbitraryValue
			] }],
			/**
			* Grayscale
			* @see https://tailwindcss.com/docs/grayscale
			*/
			grayscale: [{ grayscale: [grayscale] }],
			/**
			* Hue Rotate
			* @see https://tailwindcss.com/docs/hue-rotate
			*/
			"hue-rotate": [{ "hue-rotate": [hueRotate] }],
			/**
			* Invert
			* @see https://tailwindcss.com/docs/invert
			*/
			invert: [{ invert: [invert] }],
			/**
			* Saturate
			* @see https://tailwindcss.com/docs/saturate
			*/
			saturate: [{ saturate: [saturate] }],
			/**
			* Sepia
			* @see https://tailwindcss.com/docs/sepia
			*/
			sepia: [{ sepia: [sepia] }],
			/**
			* Backdrop Filter
			* @deprecated since Tailwind CSS v3.0.0
			* @see https://tailwindcss.com/docs/backdrop-filter
			*/
			"backdrop-filter": [{ "backdrop-filter": ["", "none"] }],
			/**
			* Backdrop Blur
			* @see https://tailwindcss.com/docs/backdrop-blur
			*/
			"backdrop-blur": [{ "backdrop-blur": [blur] }],
			/**
			* Backdrop Brightness
			* @see https://tailwindcss.com/docs/backdrop-brightness
			*/
			"backdrop-brightness": [{ "backdrop-brightness": [brightness] }],
			/**
			* Backdrop Contrast
			* @see https://tailwindcss.com/docs/backdrop-contrast
			*/
			"backdrop-contrast": [{ "backdrop-contrast": [contrast] }],
			/**
			* Backdrop Grayscale
			* @see https://tailwindcss.com/docs/backdrop-grayscale
			*/
			"backdrop-grayscale": [{ "backdrop-grayscale": [grayscale] }],
			/**
			* Backdrop Hue Rotate
			* @see https://tailwindcss.com/docs/backdrop-hue-rotate
			*/
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [hueRotate] }],
			/**
			* Backdrop Invert
			* @see https://tailwindcss.com/docs/backdrop-invert
			*/
			"backdrop-invert": [{ "backdrop-invert": [invert] }],
			/**
			* Backdrop Opacity
			* @see https://tailwindcss.com/docs/backdrop-opacity
			*/
			"backdrop-opacity": [{ "backdrop-opacity": [opacity] }],
			/**
			* Backdrop Saturate
			* @see https://tailwindcss.com/docs/backdrop-saturate
			*/
			"backdrop-saturate": [{ "backdrop-saturate": [saturate] }],
			/**
			* Backdrop Sepia
			* @see https://tailwindcss.com/docs/backdrop-sepia
			*/
			"backdrop-sepia": [{ "backdrop-sepia": [sepia] }],
			/**
			* Border Collapse
			* @see https://tailwindcss.com/docs/border-collapse
			*/
			"border-collapse": [{ border: ["collapse", "separate"] }],
			/**
			* Border Spacing
			* @see https://tailwindcss.com/docs/border-spacing
			*/
			"border-spacing": [{ "border-spacing": [borderSpacing] }],
			/**
			* Border Spacing X
			* @see https://tailwindcss.com/docs/border-spacing
			*/
			"border-spacing-x": [{ "border-spacing-x": [borderSpacing] }],
			/**
			* Border Spacing Y
			* @see https://tailwindcss.com/docs/border-spacing
			*/
			"border-spacing-y": [{ "border-spacing-y": [borderSpacing] }],
			/**
			* Table Layout
			* @see https://tailwindcss.com/docs/table-layout
			*/
			"table-layout": [{ table: ["auto", "fixed"] }],
			/**
			* Caption Side
			* @see https://tailwindcss.com/docs/caption-side
			*/
			caption: [{ caption: ["top", "bottom"] }],
			/**
			* Tranisition Property
			* @see https://tailwindcss.com/docs/transition-property
			*/
			transition: [{ transition: [
				"none",
				"all",
				"",
				"colors",
				"opacity",
				"shadow",
				"transform",
				isArbitraryValue
			] }],
			/**
			* Transition Duration
			* @see https://tailwindcss.com/docs/transition-duration
			*/
			duration: [{ duration: getNumberAndArbitrary() }],
			/**
			* Transition Timing Function
			* @see https://tailwindcss.com/docs/transition-timing-function
			*/
			ease: [{ ease: [
				"linear",
				"in",
				"out",
				"in-out",
				isArbitraryValue
			] }],
			/**
			* Transition Delay
			* @see https://tailwindcss.com/docs/transition-delay
			*/
			delay: [{ delay: getNumberAndArbitrary() }],
			/**
			* Animation
			* @see https://tailwindcss.com/docs/animation
			*/
			animate: [{ animate: [
				"none",
				"spin",
				"ping",
				"pulse",
				"bounce",
				isArbitraryValue
			] }],
			/**
			* Transform
			* @see https://tailwindcss.com/docs/transform
			*/
			transform: [{ transform: [
				"",
				"gpu",
				"none"
			] }],
			/**
			* Scale
			* @see https://tailwindcss.com/docs/scale
			*/
			scale: [{ scale: [scale] }],
			/**
			* Scale X
			* @see https://tailwindcss.com/docs/scale
			*/
			"scale-x": [{ "scale-x": [scale] }],
			/**
			* Scale Y
			* @see https://tailwindcss.com/docs/scale
			*/
			"scale-y": [{ "scale-y": [scale] }],
			/**
			* Rotate
			* @see https://tailwindcss.com/docs/rotate
			*/
			rotate: [{ rotate: [isInteger, isArbitraryValue] }],
			/**
			* Translate X
			* @see https://tailwindcss.com/docs/translate
			*/
			"translate-x": [{ "translate-x": [translate] }],
			/**
			* Translate Y
			* @see https://tailwindcss.com/docs/translate
			*/
			"translate-y": [{ "translate-y": [translate] }],
			/**
			* Skew X
			* @see https://tailwindcss.com/docs/skew
			*/
			"skew-x": [{ "skew-x": [skew] }],
			/**
			* Skew Y
			* @see https://tailwindcss.com/docs/skew
			*/
			"skew-y": [{ "skew-y": [skew] }],
			/**
			* Transform Origin
			* @see https://tailwindcss.com/docs/transform-origin
			*/
			"transform-origin": [{ origin: [
				"center",
				"top",
				"top-right",
				"right",
				"bottom-right",
				"bottom",
				"bottom-left",
				"left",
				"top-left",
				isArbitraryValue
			] }],
			/**
			* Accent Color
			* @see https://tailwindcss.com/docs/accent-color
			*/
			accent: [{ accent: ["auto", colors] }],
			/**
			* Appearance
			* @see https://tailwindcss.com/docs/appearance
			*/
			appearance: [{ appearance: ["none", "auto"] }],
			/**
			* Cursor
			* @see https://tailwindcss.com/docs/cursor
			*/
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				isArbitraryValue
			] }],
			/**
			* Caret Color
			* @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
			*/
			"caret-color": [{ caret: [colors] }],
			/**
			* Pointer Events
			* @see https://tailwindcss.com/docs/pointer-events
			*/
			"pointer-events": [{ "pointer-events": ["none", "auto"] }],
			/**
			* Resize
			* @see https://tailwindcss.com/docs/resize
			*/
			resize: [{ resize: [
				"none",
				"y",
				"x",
				""
			] }],
			/**
			* Scroll Behavior
			* @see https://tailwindcss.com/docs/scroll-behavior
			*/
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			/**
			* Scroll Margin
			* @see https://tailwindcss.com/docs/scroll-margin
			*/
			"scroll-m": [{ "scroll-m": getSpacingWithArbitrary() }],
			/**
			* Scroll Margin X
			* @see https://tailwindcss.com/docs/scroll-margin
			*/
			"scroll-mx": [{ "scroll-mx": getSpacingWithArbitrary() }],
			/**
			* Scroll Margin Y
			* @see https://tailwindcss.com/docs/scroll-margin
			*/
			"scroll-my": [{ "scroll-my": getSpacingWithArbitrary() }],
			/**
			* Scroll Margin Start
			* @see https://tailwindcss.com/docs/scroll-margin
			*/
			"scroll-ms": [{ "scroll-ms": getSpacingWithArbitrary() }],
			/**
			* Scroll Margin End
			* @see https://tailwindcss.com/docs/scroll-margin
			*/
			"scroll-me": [{ "scroll-me": getSpacingWithArbitrary() }],
			/**
			* Scroll Margin Top
			* @see https://tailwindcss.com/docs/scroll-margin
			*/
			"scroll-mt": [{ "scroll-mt": getSpacingWithArbitrary() }],
			/**
			* Scroll Margin Right
			* @see https://tailwindcss.com/docs/scroll-margin
			*/
			"scroll-mr": [{ "scroll-mr": getSpacingWithArbitrary() }],
			/**
			* Scroll Margin Bottom
			* @see https://tailwindcss.com/docs/scroll-margin
			*/
			"scroll-mb": [{ "scroll-mb": getSpacingWithArbitrary() }],
			/**
			* Scroll Margin Left
			* @see https://tailwindcss.com/docs/scroll-margin
			*/
			"scroll-ml": [{ "scroll-ml": getSpacingWithArbitrary() }],
			/**
			* Scroll Padding
			* @see https://tailwindcss.com/docs/scroll-padding
			*/
			"scroll-p": [{ "scroll-p": getSpacingWithArbitrary() }],
			/**
			* Scroll Padding X
			* @see https://tailwindcss.com/docs/scroll-padding
			*/
			"scroll-px": [{ "scroll-px": getSpacingWithArbitrary() }],
			/**
			* Scroll Padding Y
			* @see https://tailwindcss.com/docs/scroll-padding
			*/
			"scroll-py": [{ "scroll-py": getSpacingWithArbitrary() }],
			/**
			* Scroll Padding Start
			* @see https://tailwindcss.com/docs/scroll-padding
			*/
			"scroll-ps": [{ "scroll-ps": getSpacingWithArbitrary() }],
			/**
			* Scroll Padding End
			* @see https://tailwindcss.com/docs/scroll-padding
			*/
			"scroll-pe": [{ "scroll-pe": getSpacingWithArbitrary() }],
			/**
			* Scroll Padding Top
			* @see https://tailwindcss.com/docs/scroll-padding
			*/
			"scroll-pt": [{ "scroll-pt": getSpacingWithArbitrary() }],
			/**
			* Scroll Padding Right
			* @see https://tailwindcss.com/docs/scroll-padding
			*/
			"scroll-pr": [{ "scroll-pr": getSpacingWithArbitrary() }],
			/**
			* Scroll Padding Bottom
			* @see https://tailwindcss.com/docs/scroll-padding
			*/
			"scroll-pb": [{ "scroll-pb": getSpacingWithArbitrary() }],
			/**
			* Scroll Padding Left
			* @see https://tailwindcss.com/docs/scroll-padding
			*/
			"scroll-pl": [{ "scroll-pl": getSpacingWithArbitrary() }],
			/**
			* Scroll Snap Align
			* @see https://tailwindcss.com/docs/scroll-snap-align
			*/
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			/**
			* Scroll Snap Stop
			* @see https://tailwindcss.com/docs/scroll-snap-stop
			*/
			"snap-stop": [{ snap: ["normal", "always"] }],
			/**
			* Scroll Snap Type
			* @see https://tailwindcss.com/docs/scroll-snap-type
			*/
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			/**
			* Scroll Snap Type Strictness
			* @see https://tailwindcss.com/docs/scroll-snap-type
			*/
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			/**
			* Touch Action
			* @see https://tailwindcss.com/docs/touch-action
			*/
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			/**
			* Touch Action X
			* @see https://tailwindcss.com/docs/touch-action
			*/
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			/**
			* Touch Action Y
			* @see https://tailwindcss.com/docs/touch-action
			*/
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			/**
			* Touch Action Pinch Zoom
			* @see https://tailwindcss.com/docs/touch-action
			*/
			"touch-pz": ["touch-pinch-zoom"],
			/**
			* User Select
			* @see https://tailwindcss.com/docs/user-select
			*/
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			/**
			* Will Change
			* @see https://tailwindcss.com/docs/will-change
			*/
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				isArbitraryValue
			] }],
			/**
			* Fill
			* @see https://tailwindcss.com/docs/fill
			*/
			fill: [{ fill: [colors, "none"] }],
			/**
			* Stroke Width
			* @see https://tailwindcss.com/docs/stroke-width
			*/
			"stroke-w": [{ stroke: [
				isLength,
				isArbitraryLength,
				isArbitraryNumber
			] }],
			/**
			* Stroke
			* @see https://tailwindcss.com/docs/stroke
			*/
			stroke: [{ stroke: [colors, "none"] }],
			/**
			* Screen Readers
			* @see https://tailwindcss.com/docs/screen-readers
			*/
			sr: ["sr-only", "not-sr-only"],
			/**
			* Forced Color Adjust
			* @see https://tailwindcss.com/docs/forced-color-adjust
			*/
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-s",
				"border-w-e",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] }
	};
}
var twMerge = /*#__PURE__*/ createTailwindMerge(getDefaultConfig);
//#endregion
//#region src/className/className.ts
function cn(...inputs) {
	return twMerge(clsx(inputs));
}
//#endregion
//#region ../types/dist/index.js
var t = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20
};
var n = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM"
};
t.Dhl, t.Instabox;
t.PostNl, n.PostNl, t.Bpost, n.Bpost, t.CheapCargo, n.CheapCargo, t.Dpd, n.Dpd, t.Instabox, n.Instabox, t.Dhl, n.Dhl, t.Bol, n.Bol, t.Ups, n.Ups, t.DhlForYou, n.DhlForYou, t.DhlParcelConnect, n.DhlParcelConnect, t.DhlEuroPlus, n.DhlEuroPlus, t.UpsStandard, n.UpsStandard, t.UpsExpressSaver, n.UpsExpressSaver, t.Gls, n.Gls, t.Brt, n.Brt, t.Trunkrs, n.Trunkrs, t.InPost, n.InPost, t.PosteItaliane, n.PosteItaliane, t.Spring, n.Spring, t.ViaTim, n.ViaTim;
t.PostNl, n.POSTNL, t.Bpost, n.BPOST, t.CheapCargo, n.CHEAP_CARGO, t.Dpd, n.DPD, t.Instabox, n.INSTABOX, t.Dhl, n.DHL, t.Bol, n.BOL, t.Ups, n.UPS, t.DhlForYou, n.DHL_FOR_YOU, t.DhlParcelConnect, n.DHL_PARCEL_CONNECT, t.DhlEuroPlus, n.DHL_EUROPLUS, t.UpsStandard, n.UPS_STANDARD, t.UpsExpressSaver, n.UPS_EXPRESS_SAVER, t.Gls, n.GLS, t.Brt, n.BRT, t.Trunkrs, n.TRUNKRS, t.InPost, n.INPOST, t.PosteItaliane, n.POSTE_ITALIANE, t.Spring, n.SPRING, t.ViaTim, n.VIA_TIM;
n.PostNl, t.PostNl, n.POSTNL, t.PostNl, n.Bpost, t.Bpost, n.BPOST, t.Bpost, n.CheapCargo, t.CheapCargo, n.CHEAP_CARGO, t.CheapCargo, n.Dpd, t.Dpd, n.DPD, t.Dpd, n.Instabox, t.Instabox, n.Dhl, t.Dhl, n.BolCom, t.Bol, n.Bol, t.Bol, n.BOL, t.Bol, n.Ups, t.Ups, n.DhlForYou, t.DhlForYou, n.DHL_FOR_YOU, t.DhlForYou, n.DhlParcelConnect, t.DhlParcelConnect, n.DHL_PARCEL_CONNECT, t.DhlParcelConnect, n.DhlEuroPlus, t.DhlEuroPlus, n.DHL_EUROPLUS, t.DhlEuroPlus, n.UpsStandard, t.UpsStandard, n.UPS_STANDARD, t.UpsStandard, n.UpsExpressSaver, t.UpsExpressSaver, n.UPS_EXPRESS_SAVER, t.UpsExpressSaver, n.Gls, t.Gls, n.GLS, t.Gls, n.Brt, t.Brt, n.BRT, t.Brt, n.Trunkrs, t.Trunkrs, n.TRUNKRS, t.Trunkrs, n.InPost, t.InPost, n.INPOST, t.InPost, n.PosteItaliane, t.PosteItaliane, n.POSTE_ITALIANE, t.PosteItaliane, n.Spring, t.Spring, n.SPRING, t.Spring, n.ViaTim, t.ViaTim, n.VIA_TIM, t.ViaTim;
t.PostNl, t.Bpost, t.CheapCargo, t.Dpd, t.Instabox, t.Dhl, t.Bol, t.Ups, t.DhlForYou, t.DhlParcelConnect, t.DhlEuroPlus, t.UpsStandard, t.UpsExpressSaver, t.Gls, t.Brt, t.Trunkrs, t.InPost, t.PosteItaliane, t.ViaTim;
var o = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
o.Austria, o.Belgium, o.Bulgaria, o.Croatia, o.Cyprus, o.CzechRepublic, o.Denmark, o.Estonia, o.Finland, o.France, o.Germany, o.Greece, o.Hungary, o.Ireland, o.Italy, o.Latvia, o.Lithuania, o.Luxembourg, o.Malta, o.Netherlands, o.Poland, o.Portugal, o.Romania, o.Slovakia, o.Slovenia, o.Spain, o.Sweden;
Object.values(o);
o.Angola, o.AntiguaAndBarbuda, o.Aruba, o.Bahamas, o.Belize, o.Benin, o.Bermuda, o.BonaireSintEustatiusAndSaba, o.Botswana, o.BurkinaFaso, o.Burundi, o.Cameroon, o.CanaryIslands, o.CentralAfricanRepublic, o.Comoros, o.CongoBrazzaville, o.CongoKinshasa, o.CoteDIvoire, o.Curacao, o.Djibouti, o.Dominica, o.DutchAntilles, o.EquatorialGuinea, o.Eritrea, o.Fiji, o.Gabon, o.Gambia, o.Ghana, o.Grenada, o.Guyana, o.HongKong, o.Kiribati, o.KoreaPeoplesDemocraticRepublic, o.Macao, o.Malawi, o.Mali, o.Mauritania, o.Nauru, o.Qatar, o.Rwanda, o.SaintKittsAndNevis, o.SaoTomeAndPrincipe, o.Seychelles, o.SierraLeone, o.SintMaarten, o.Suriname, o.SyrianArabRepublic, o.TimorLeste, o.Togo, o.Tonga, o.Tuvalu, o.Uganda, o.UnitedArabEmirates, o.Vanuatu, o.Yemen, o.Zimbabwe;
o.Austria, o.Belgium, o.Bulgaria, o.Croatia, o.CzechRepublic, o.Estonia, o.Finland, o.France, o.Germany, o.Greece, o.Hungary, o.Ireland, o.Italy, o.Latvia, o.Lithuania, o.Luxembourg, o.Malta, o.Netherlands, o.Portugal, o.Romania, o.Slovakia, o.Slovenia, o.Spain, o.UnitedKingdom;
o.Denmark, o.Germany, o.Sweden;
var s = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
};
var c = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
};
var l = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
s.EarlyMorning, c.EarlyMorning, s.Morning, c.Morning, s.Standard, c.Standard, s.Evening, c.Evening, s.Pickup, c.Pickup, s.PickupExpress, c.PickupExpress, s.SameDayDelivery, c.SameDayDelivery, s.Express, c.Express;
c.EarlyMorning, s.EarlyMorning, c.Morning, s.Morning, c.Standard, s.Standard, c.Evening, s.Evening, c.Pickup, s.Pickup, c.PickupExpress, s.PickupExpress, c.SameDayDelivery, s.SameDayDelivery, c.Express, s.Express;
s.EarlyMorning, l.EarlyMorning, s.Morning, l.Morning, s.Standard, l.Standard, s.Evening, l.Evening, s.Pickup, l.Pickup, s.PickupExpress, l.PickupExpress, s.SameDayDelivery, l.SameDayDelivery, s.Express, l.Express;
l.EarlyMorning, c.EarlyMorning, l.Morning, c.Morning, l.Standard, c.Standard, l.Evening, c.Evening, l.Pickup, c.Pickup, l.PickupExpress, c.PickupExpress, l.SameDayDelivery, c.SameDayDelivery, l.Express, c.Express;
s.EarlyMorning, s.Morning, s.Standard, s.Evening, s.Pickup, s.PickupExpress, s.SameDayDelivery, s.Express;
({ Vasco: 1 }).Vasco, { Vasco: "vasco" }.Vasco;
var p = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
};
var m = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
m.Sunday, p.Sunday, m.Monday, p.Monday, m.Tuesday, p.Tuesday, m.Wednesday, p.Wednesday, m.Thursday, p.Thursday, m.Friday, p.Friday, m.Saturday, p.Saturday;
p.Sunday, m.Sunday, p.Monday, m.Monday, p.Tuesday, m.Tuesday, p.Wednesday, m.Wednesday, p.Thursday, m.Thursday, p.Friday, m.Friday, p.Saturday, m.Saturday;
var g = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
g.Bytes, g.Kilobytes, g.Megabytes, g.Gigabytes, g.Terabytes;
var _ = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
};
var v = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
_.Bol, v.Bol, _.Exact, v.Exact, _.Amazon, v.Amazon, _.Wix, v.Wix, _.ExactDe, v.ExactDe, _.Etsy, v.Etsy;
v.Bol, _.Bol, v.Exact, _.Exact, v.Amazon, _.Amazon, v.Wix, _.Wix, v.ExactDe, _.ExactDe, v.Etsy, _.Etsy;
var x = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
};
var S = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
x.Unpaid, S.Unpaid, x.Due, S.Due, x.DuePrepayment, S.DuePrepayment, x.Reminder1, S.Reminder1, x.Reminder2, S.Reminder2, x.Dun, S.Dun, x.Collection, S.Collection, x.Instalments, S.Instalments, x.PaymentArrangement, S.PaymentArrangement, x.Dispute, S.Dispute, x.LegalProcedure, S.LegalProcedure, x.Insolvency, S.Insolvency, x.WriteOff, S.WriteOff, x.Pending, S.Pending, x.Cancelled, S.Cancelled, x.Paid, S.Paid, x.PaidOnline, S.PaidOnline, x.PaidAutomatic, S.PaidAutomatic, x.PaidCredit, S.PaidCredit, x.PaidZeroItems, S.PaidZeroItems, x.InvoiceWith0InvoiceItemsPaidZeroBalance, S.PaidZeroBalance;
x.Due, x.Reminder1, x.Reminder2, x.Dun, x.Collection, x.Instalments, x.PaymentArrangement, x.Dispute;
x.Paid, x.PaidOnline, x.PaidAutomatic, x.PaidCredit, x.PaidZeroItems;
var jt = {
	Gram: "gram",
	Kilogram: "kilogram"
};
var C = {
	Gram: "g",
	Kilogram: "kg"
};
var Mt = {
	[C.Gram]: 1,
	[C.Kilogram]: 1e3
};
var Nt = {
	Millimeter: "millimeter",
	Centimeter: "centimeter",
	Meter: "meter"
};
var w = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
var Pt = {
	[w.Millimeter]: .1,
	[w.Centimeter]: 1,
	[w.Meter]: 100
};
var T = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
};
var E = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
E.PendingConcept;
E.PendingRegistered;
E.EnRouteHandedToCarrier, E.EnRouteSorting, E.EnRouteDistribution, E.EnRouteCustoms;
E.DeliveredReadyForPickup;
E.DeliveredAtRecipient, E.DeliveredPackagePickedUp;
var D = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
};
var O = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
O.Light, D.Light, O.Start, D.Start, O.Plus, D.Plus, O.Premium, D.Premium, O.Max, D.Max;
D.Light, O.Light, D.Start, O.Start, D.Plus, O.Plus, D.Premium, O.Premium, D.Max, O.Max;
var j = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
};
var M = {
	Start: D.Start,
	Plus: D.Plus,
	Premium: D.Premium,
	Max: D.Max
};
j.Start, M.Start, j.Plus, M.Plus, j.Premium, M.Premium, j.Max, M.Max;
M.Start, j.Start, M.Plus, j.Plus, M.Premium, j.Premium, M.Max, j.Max;
var F = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
};
var I = {
	Start: D.Start,
	Plus: D.Plus,
	Premium: D.Premium,
	Max: D.Max
};
F.Start, I.Start, F.Plus, I.Plus, F.Premium, I.Premium, F.Max, I.Max;
I.Start, F.Start, I.Plus, F.Plus, I.Premium, F.Premium, I.Max, F.Max;
var z = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
};
var B = {
	Light: D.Light,
	Start: D.Start,
	Plus: D.Plus,
	Premium: D.Premium,
	Max: D.Max
};
z.Light, B.Light, z.Start, B.Start, z.Plus, B.Plus, z.Premium, B.Premium, z.Max, B.Max;
B.Light, z.Light, B.Start, z.Start, B.Plus, z.Plus, B.Premium, z.Premium, B.Max, z.Max;
var V = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
};
var H = {
	Start: D.Start,
	Plus: D.Plus,
	Premium: D.Premium,
	Max: D.Max
};
V.Start, H.Start, V.Plus, H.Plus, V.Premium, H.Premium, V.Max, H.Max;
H.Start, V.Start, H.Plus, V.Plus, H.Premium, V.Premium, H.Max, V.Max;
var U = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
};
var W = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
};
var G = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
U.MyParcel, W.MyParcel, U.Flespakket, W.Flespakket, U.SendMyParcel, W.SendMyParcel, U.MyParcelIt, W.MyParcelIt, U.DeliverDutch, W.DeliverDutch, U.PostNlPlugin, W.PostNlPlugin;
U.MyParcel, G.MyParcelNl, U.Flespakket, G.MyParcelNl, U.SendMyParcel, G.MyParcelBe, U.MyParcelIt, G.MyParcelIt, U.DeliverDutch, G.DeliverDutch, U.PostNlPlugin, G.PostNlPlugin;
G.MyParcelNl, U.MyParcel, G.MyParcelBe, U.SendMyParcel, G.MyParcelIt, U.MyParcelIt;
G.MyParcelNl, T.HomeCountry, o.Netherlands, T.Eu, T.Row, o.Belgium, G.MyParcelBe, T.HomeCountry, o.Belgium, o.Netherlands, T.Eu, T.Row;
G.MyParcelBe, T.HomeCountry, o.Belgium, T.Eu, T.Row;
G.MyParcelNl, T.HomeCountry, o.Netherlands, T.Eu, T.Row;
G.MyParcelNl, T.HomeCountry, o.Netherlands, o.Belgium, o.Luxembourg;
t.Bpost, t.PostNl, t.DhlForYou, t.DhlParcelConnect, t.DhlEuroPlus, t.Ups, t.UpsStandard, t.UpsExpressSaver;
var J = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
};
var Y = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
J.Package, Y.Package, J.Mailbox, Y.Mailbox, J.Letter, Y.Letter, J.DigitalStamp, Y.DigitalStamp, J.Pallet, Y.Pallet, J.PackageSmall, Y.PackageSmall, J.Envelope, Y.Envelope;
Y.Package, J.Package, Y.Mailbox, J.Mailbox, Y.Letter, J.Letter, Y.DigitalStamp, J.DigitalStamp, Y.Pallet, J.Pallet, Y.PackageSmall, J.PackageSmall, Y.Envelope, J.Envelope;
var Z = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
J.Package, Z.PACKAGE, J.Mailbox, Z.MAILBOX, J.Letter, Z.UNFRANKED, J.DigitalStamp, Z.DIGITAL_STAMP, J.Pallet, Z.PALLET, J.PackageSmall, Z.SMALL_PACKAGE, J.Envelope, Z.ENVELOPE;
Z.PACKAGE, J.Package, Z.MAILBOX, J.Mailbox, Z.UNFRANKED, J.Letter, Z.DIGITAL_STAMP, J.DigitalStamp, Z.PALLET, J.Pallet, Z.SMALL_PACKAGE, J.PackageSmall, Z.ENVELOPE, J.Envelope;
J.Package, J.Mailbox, J.Letter, J.DigitalStamp, J.Pallet, J.PackageSmall, J.Envelope;
var $ = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
$.PendingConcept, $.PendingRegistered;
$.EnrouteHandedToCarrier, $.EnrouteSorting, $.EnrouteDistribution, $.DeliveredAtCustoms;
$.DeliveredAtRecipient, $.DeliveredPackagePickedUp, $.DeliveredReturnShipmentPackagePickedUp, $.DeliveredAtAgreedLocation;
$.PrintedLetter, $.PrintedDigitalStamp;
$.InactiveConcept, $.InactiveRegistered, $.InactiveEnrouteHandedToCarrier, $.InactiveEnrouteSorting, $.InactiveEnrouteDistribution, $.InactiveEnrouteCustoms, $.InactiveDeliveredAtRecipient, $.InactiveDeliveredReadyForPickup, $.InactiveDeliveredPackagePickedUp;
//#endregion
//#region src/country/isCC/isCC.ts
var isUnitedKingdom = (countryCode) => {
	return countryCode === o.UnitedKingdom;
};
var isNetherlands = (countryCode) => {
	return countryCode === o.Netherlands;
};
var isBelgium = (countryCode) => {
	return countryCode === o.Belgium;
};
var isGermany = (countryCode) => {
	return countryCode === o.Germany;
};
var isFrance = (countryCode) => {
	return countryCode === o.France;
};
var isIreland = (countryCode) => {
	return countryCode === o.Ireland;
};
var isUnitedStatesOfAmerica = (countryCode) => {
	return countryCode === o.UnitedStatesOfAmerica;
};
var isPuertoRico = (countryCode) => {
	return countryCode === o.PuertoRico;
};
//#endregion
//#region src/country/index.ts
/* c8 ignore start */
var country = { countryCode: /* @__PURE__ */ __exportAll({
	isBelgium: () => isBelgium,
	isFrance: () => isFrance,
	isGermany: () => isGermany,
	isIreland: () => isIreland,
	isNetherlands: () => isNetherlands,
	isPuertoRico: () => isPuertoRico,
	isUnitedKingdom: () => isUnitedKingdom,
	isUnitedStatesOfAmerica: () => isUnitedStatesOfAmerica
}) };
//#endregion
//#region ../../node_modules/.pnpm/dayjs@1.11.10/node_modules/dayjs/dayjs.min.js
var require_dayjs_min = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function(t, e) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs = e();
	})(exports, (function() {
		"use strict";
		var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(t) {
				var e = [
					"th",
					"st",
					"nd",
					"rd"
				], n = t % 100;
				return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
			}
		}, m = function(t, e, n) {
			var r = String(t);
			return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
		}, v = {
			s: m,
			z: function(t) {
				var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
				return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
			},
			m: function t(e, n) {
				if (e.date() < n.date()) return -t(n, e);
				var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
				return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
			},
			a: function(t) {
				return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
			},
			p: function(t) {
				return {
					M: c,
					y: h,
					w: o,
					d: a,
					D: d,
					h: u,
					m: s,
					s: i,
					ms: r,
					Q: f
				}[t] || String(t || "").toLowerCase().replace(/s$/, "");
			},
			u: function(t) {
				return void 0 === t;
			}
		}, g = "en", D = {};
		D[g] = M;
		var p = "$isDayjsObject", S = function(t) {
			return t instanceof _ || !(!t || !t[p]);
		}, w = function t(e, n, r) {
			var i;
			if (!e) return g;
			if ("string" == typeof e) {
				var s = e.toLowerCase();
				D[s] && (i = s), n && (D[s] = n, i = s);
				var u = e.split("-");
				if (!i && u.length > 1) return t(u[0]);
			} else {
				var a = e.name;
				D[a] = e, i = a;
			}
			return !r && i && (g = i), i || !r && g;
		}, O = function(t, e) {
			if (S(t)) return t.clone();
			var n = "object" == typeof e ? e : {};
			return n.date = t, n.args = arguments, new _(n);
		}, b = v;
		b.l = w, b.i = S, b.w = function(t, e) {
			return O(t, {
				locale: e.$L,
				utc: e.$u,
				x: e.$x,
				$offset: e.$offset
			});
		};
		var _ = function() {
			function M(t) {
				this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
			}
			var m = M.prototype;
			return m.parse = function(t) {
				this.$d = function(t) {
					var e = t.date, n = t.utc;
					if (null === e) return /* @__PURE__ */ new Date(NaN);
					if (b.u(e)) return /* @__PURE__ */ new Date();
					if (e instanceof Date) return new Date(e);
					if ("string" == typeof e && !/Z$/i.test(e)) {
						var r = e.match($);
						if (r) {
							var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
						}
					}
					return new Date(e);
				}(t), this.init();
			}, m.init = function() {
				var t = this.$d;
				this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
			}, m.$utils = function() {
				return b;
			}, m.isValid = function() {
				return !(this.$d.toString() === l);
			}, m.isSame = function(t, e) {
				var n = O(t);
				return this.startOf(e) <= n && n <= this.endOf(e);
			}, m.isAfter = function(t, e) {
				return O(t) < this.startOf(e);
			}, m.isBefore = function(t, e) {
				return this.endOf(e) < O(t);
			}, m.$g = function(t, e, n) {
				return b.u(t) ? this[e] : this.set(n, t);
			}, m.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, m.valueOf = function() {
				return this.$d.getTime();
			}, m.startOf = function(t, e) {
				var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
					var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
					return r ? i : i.endOf(a);
				}, $ = function(t, e) {
					return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(e)), n);
				}, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (f) {
					case h: return r ? l(1, 0) : l(31, 11);
					case c: return r ? l(1, M) : l(0, M + 1);
					case o:
						var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
						return l(r ? m - D : m + (6 - D), M);
					case a:
					case d: return $(v + "Hours", 0);
					case u: return $(v + "Minutes", 1);
					case s: return $(v + "Seconds", 2);
					case i: return $(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, m.endOf = function(t) {
				return this.startOf(t, !1);
			}, m.$set = function(t, e) {
				var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
				if (o === c || o === h) {
					var y = this.clone().set(d, 1);
					y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
				} else l && this.$d[l]($);
				return this.init(), this;
			}, m.set = function(t, e) {
				return this.clone().$set(t, e);
			}, m.get = function(t) {
				return this[b.p(t)]();
			}, m.add = function(r, f) {
				var d, l = this;
				r = Number(r);
				var $ = b.p(f), y = function(t) {
					var e = O(l);
					return b.w(e.date(e.date() + Math.round(t * r)), l);
				};
				if ($ === c) return this.set(c, this.$M + r);
				if ($ === h) return this.set(h, this.$y + r);
				if ($ === a) return y(1);
				if ($ === o) return y(7);
				var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
				return b.w(m, this);
			}, m.subtract = function(t, e) {
				return this.add(-1 * t, e);
			}, m.format = function(t) {
				var e = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || l;
				var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
					return t && (t[n] || t(e, r)) || i[n].slice(0, s);
				}, d = function(t) {
					return b.s(s % 12 || 12, t, "0");
				}, $ = f || function(t, e, n) {
					var r = t < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(y, (function(t, r) {
					return r || function(t) {
						switch (t) {
							case "YY": return String(e.$y).slice(-2);
							case "YYYY": return b.s(e.$y, 4, "0");
							case "M": return a + 1;
							case "MM": return b.s(a + 1, 2, "0");
							case "MMM": return h(n.monthsShort, a, c, 3);
							case "MMMM": return h(c, a);
							case "D": return e.$D;
							case "DD": return b.s(e.$D, 2, "0");
							case "d": return String(e.$W);
							case "dd": return h(n.weekdaysMin, e.$W, o, 2);
							case "ddd": return h(n.weekdaysShort, e.$W, o, 3);
							case "dddd": return o[e.$W];
							case "H": return String(s);
							case "HH": return b.s(s, 2, "0");
							case "h": return d(1);
							case "hh": return d(2);
							case "a": return $(s, u, !0);
							case "A": return $(s, u, !1);
							case "m": return String(u);
							case "mm": return b.s(u, 2, "0");
							case "s": return String(e.$s);
							case "ss": return b.s(e.$s, 2, "0");
							case "SSS": return b.s(e.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(t) || i.replace(":", "");
				}));
			}, m.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, m.diff = function(r, d, l) {
				var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
					return b.m(y, m);
				};
				switch (M) {
					case h:
						$ = D() / 12;
						break;
					case c:
						$ = D();
						break;
					case f:
						$ = D() / 3;
						break;
					case o:
						$ = (g - v) / 6048e5;
						break;
					case a:
						$ = (g - v) / 864e5;
						break;
					case u:
						$ = g / n;
						break;
					case s:
						$ = g / e;
						break;
					case i:
						$ = g / t;
						break;
					default: $ = g;
				}
				return l ? $ : b.a($);
			}, m.daysInMonth = function() {
				return this.endOf(c).$D;
			}, m.$locale = function() {
				return D[this.$L];
			}, m.locale = function(t, e) {
				if (!t) return this.$L;
				var n = this.clone(), r = w(t, e, !0);
				return r && (n.$L = r), n;
			}, m.clone = function() {
				return b.w(this.$d, this);
			}, m.toDate = function() {
				return new Date(this.valueOf());
			}, m.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, m.toISOString = function() {
				return this.$d.toISOString();
			}, m.toString = function() {
				return this.$d.toUTCString();
			}, M;
		}(), k = _.prototype;
		return O.prototype = k, [
			["$ms", r],
			["$s", i],
			["$m", s],
			["$H", u],
			["$W", a],
			["$M", c],
			["$y", h],
			["$D", d]
		].forEach((function(t) {
			k[t[1]] = function(e) {
				return this.$g(e, t[0], t[1]);
			};
		})), O.extend = function(t, e) {
			return t.$i || (t(e, _, O), t.$i = !0), O;
		}, O.locale = w, O.isDayjs = S, O.unix = function(t) {
			return O(1e3 * t);
		}, O.en = D[g], O.Ls = D, O.p = {}, O;
	}));
}));
//#endregion
//#region ../../node_modules/.pnpm/dayjs@1.11.10/node_modules/dayjs/locale/nl.js
var require_nl = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function(e, a) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = a(require_dayjs_min()) : "function" == typeof define && define.amd ? define(["dayjs"], a) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_locale_nl = a(e.dayjs);
	})(exports, (function(e) {
		"use strict";
		function a(e) {
			return e && "object" == typeof e && "default" in e ? e : { default: e };
		}
		var d = a(e), n = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (1 === e || 8 === e || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return d.default.locale(n, null, !0), n;
	}));
}));
//#endregion
//#region ../../node_modules/.pnpm/dayjs@1.11.10/node_modules/dayjs/locale/it.js
var require_it = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function(e, o) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = o(require_dayjs_min()) : "function" == typeof define && define.amd ? define(["dayjs"], o) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_locale_it = o(e.dayjs);
	})(exports, (function(e) {
		"use strict";
		function o(e) {
			return e && "object" == typeof e && "default" in e ? e : { default: e };
		}
		var t = o(e), n = {
			name: "it",
			weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
			weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
			weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
			months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
			weekStart: 1,
			monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "tra %s",
				past: "%s fa",
				s: "qualche secondo",
				m: "un minuto",
				mm: "%d minuti",
				h: "un' ora",
				hh: "%d ore",
				d: "un giorno",
				dd: "%d giorni",
				M: "un mese",
				MM: "%d mesi",
				y: "un anno",
				yy: "%d anni"
			},
			ordinal: function(e) {
				return e + "º";
			}
		};
		return t.default.locale(n, null, !0), n;
	}));
}));
//#endregion
//#region ../../node_modules/.pnpm/dayjs@1.11.10/node_modules/dayjs/locale/fr.js
var require_fr = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function(e, n) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = n(require_dayjs_min()) : "function" == typeof define && define.amd ? define(["dayjs"], n) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_locale_fr = n(e.dayjs);
	})(exports, (function(e) {
		"use strict";
		function n(e) {
			return e && "object" == typeof e && "default" in e ? e : { default: e };
		}
		var t = n(e), i = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (1 === e ? "er" : "");
			}
		};
		return t.default.locale(i, null, !0), i;
	}));
}));
//#endregion
//#region ../../node_modules/.pnpm/dayjs@1.11.10/node_modules/dayjs/plugin/calendar.js
var require_calendar = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function(e, t) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_calendar = t();
	})(exports, (function() {
		"use strict";
		return function(e, t, a) {
			var n = "h:mm A", d = {
				lastDay: "[Yesterday at] " + n,
				sameDay: "[Today at] " + n,
				nextDay: "[Tomorrow at] " + n,
				nextWeek: "dddd [at] " + n,
				lastWeek: "[Last] dddd [at] " + n,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var n = t || this.$locale().calendar || d, o = a(e || void 0).startOf("d"), s = this.diff(o, "d", !0), i = "sameElse", f = s < -6 ? i : s < -1 ? "lastWeek" : s < 0 ? "lastDay" : s < 1 ? "sameDay" : s < 2 ? "nextDay" : s < 7 ? "nextWeek" : i, l = n[f] || d[f];
				return "function" == typeof l ? l.call(this, a()) : this.format(l);
			};
		};
	}));
}));
//#endregion
//#region ../../node_modules/.pnpm/dayjs@1.11.10/node_modules/dayjs/plugin/customParseFormat.js
var require_customParseFormat = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function(e, t) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_customParseFormat = t();
	})(exports, (function() {
		"use strict";
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		};
		var a = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, f = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone || (this.zone = {})).offset = function(e) {
				if (!e) return 0;
				if ("Z" === e) return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return 0 === n ? 0 : "+" === t[0] ? -n : n;
			}(e);
		}], h = function(e) {
			var t = o[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = o.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * +e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * +e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, a("seconds")],
			ss: [r, a("seconds")],
			m: [r, a("minutes")],
			mm: [r, a("minutes")],
			H: [r, a("hours")],
			h: [r, a("hours")],
			HH: [r, a("hours")],
			hh: [r, a("hours")],
			D: [r, a("day")],
			DD: [n, a("day")],
			Do: [i, function(e) {
				var t = o.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			M: [r, a("month")],
			MM: [n, a("month")],
			MMM: [i, function(e) {
				var t = h("months"), n = (h("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw new Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = h("months").indexOf(e) + 1;
				if (t < 1) throw new Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, a("year")],
			YY: [n, function(e) {
				this.year = s(e);
			}],
			YYYY: [/\d{4}/, a("year")],
			Z: f,
			ZZ: f
		};
		function c(n) {
			var r = n, i = o && o.formats;
			for (var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var o = r && r.toUpperCase();
				return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), a = s.length, f = 0; f < a; f += 1) {
				var h = s[f], u = d[h], c = u && u[0], l = u && u[1];
				s[f] = l ? {
					regex: c,
					parser: l
				} : h.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < a; n += 1) {
					var i = s[n];
					if ("string" == typeof i) r += i.length;
					else {
						var o = i.regex, f = i.parser, h = e.slice(r), u = o.exec(h)[0];
						f.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (void 0 !== t) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, s = e.args;
				this.$u = r;
				var a = s[1];
				if ("string" == typeof a) {
					var f = !0 === s[2], h = !0 === s[3], u = f || h, d = s[2];
					h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date(("X" === t ? 1e3 : 1) * e);
							var r = c(t)(e), i = r.year, o = r.month, s = r.day, a = r.hours, f = r.minutes, h = r.seconds, u = r.milliseconds, d = r.zone, l = /* @__PURE__ */ new Date(), m = s || (i || o ? 1 : l.getDate()), M = i || l.getFullYear(), Y = 0;
							i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
							var p = a || 0, v = f || 0, D = h || 0, g = u || 0;
							return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
						} catch (e) {
							return /* @__PURE__ */ new Date("");
						}
					}(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = /* @__PURE__ */ new Date("")), o = {};
				} else if (a instanceof Array) for (var l = a.length, m = 1; m <= l; m += 1) {
					s[1] = a[m - 1];
					var M = n.apply(this, s);
					if (M.isValid()) {
						this.$d = M.$d, this.$L = M.$L, this.init();
						break;
					}
					m === l && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
}));
//#endregion
//#region ../../node_modules/.pnpm/dayjs@1.11.10/node_modules/dayjs/plugin/isBetween.js
var require_isBetween = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function(e, i) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = i() : "function" == typeof define && define.amd ? define(i) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_isBetween = i();
	})(exports, (function() {
		"use strict";
		return function(e, i, t) {
			i.prototype.isBetween = function(e, i, s, f) {
				var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
				return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
			};
		};
	}));
}));
//#endregion
//#region ../../node_modules/.pnpm/dayjs@1.11.10/node_modules/dayjs/plugin/isLeapYear.js
var require_isLeapYear = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function(e, t) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_isLeapYear = t();
	})(exports, (function() {
		"use strict";
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
}));
//#endregion
//#region ../../node_modules/.pnpm/dayjs@1.11.10/node_modules/dayjs/plugin/timezone.js
var require_timezone = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function(t, e) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_timezone = e();
	})(exports, (function() {
		"use strict";
		var t = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, e = {};
		return function(n, i, o) {
			var r, a = function(t, n, i) {
				void 0 === i && (i = {});
				var o = new Date(t);
				return function(t, n) {
					void 0 === n && (n = {});
					var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
					return r || (r = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: t,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: i
					}), e[o] = r), r;
				}(n, i).formatToParts(o);
			}, u = function(e, n) {
				for (var i = a(e, n), r = [], u = 0; u < i.length; u += 1) {
					var f = i[u], s = f.type, m = f.value, c = t[s];
					c >= 0 && (r[c] = parseInt(m, 10));
				}
				var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
				return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
			}, f = i.prototype;
			f.tz = function(t, e) {
				void 0 === t && (t = r);
				var n = this.utcOffset(), i = this.toDate(), a = i.toLocaleString("en-US", { timeZone: t }), u = Math.round((i - new Date(a)) / 1e3 / 60), f = o(a, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(i.getTimezoneOffset() / 15) - u, !0);
				if (e) {
					var s = f.utcOffset();
					f = f.add(n - s, "minute");
				}
				return f.$x.$timezone = t, f;
			}, f.offsetName = function(t) {
				var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, { timeZoneName: t }).find((function(t) {
					return "timezonename" === t.type.toLowerCase();
				}));
				return n && n.value;
			};
			var s = f.startOf;
			f.startOf = function(t, e) {
				if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
				var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return s.call(n, t, e).tz(this.$x.$timezone, !0);
			}, o.tz = function(t, e, n) {
				var i = n && e, a = n || e || r, f = u(+o(), a);
				if ("string" != typeof t) return o(t).tz(a);
				var s = function(t, e, n) {
					var i = t - 60 * e * 1e3, o = u(i, n);
					if (e === o) return [i, e];
					var r = u(i -= 60 * (o - e) * 1e3, n);
					return o === r ? [i, o] : [t - 60 * Math.min(o, r) * 1e3, Math.max(o, r)];
				}(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
				return d.$x.$timezone = a, d;
			}, o.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, o.tz.setDefault = function(t) {
				r = t;
			};
		};
	}));
}));
//#endregion
//#region ../../node_modules/.pnpm/dayjs@1.11.10/node_modules/dayjs/plugin/utc.js
var require_utc = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	(function(t, i) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = i() : "function" == typeof define && define.amd ? define(i) : (t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs_plugin_utc = i();
	})(exports, (function() {
		"use strict";
		var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
		return function(s, f, n) {
			var u = f.prototype;
			n.utc = function(t) {
				return new f({
					date: t,
					utc: !0,
					args: arguments
				});
			}, u.utc = function(i) {
				var e = n(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return i ? e.add(this.utcOffset(), t) : e;
			}, u.local = function() {
				return n(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var o = u.parse;
			u.parse = function(t) {
				t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
			};
			var r = u.init;
			u.init = function() {
				if (this.$u) {
					var t = this.$d;
					this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
				} else r.call(this);
			};
			var a = u.utcOffset;
			u.utcOffset = function(s, f) {
				var n = this.$utils().u;
				if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
				if ("string" == typeof s && (s = function(t) {
					void 0 === t && (t = "");
					var s = t.match(i);
					if (!s) return null;
					var f = ("" + s[0]).match(e) || [
						"-",
						0,
						0
					], n = f[0], u = 60 * +f[1] + +f[2];
					return 0 === u ? 0 : "+" === n ? u : -u;
				}(s), null === s)) return this;
				var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
				if (f) return o.$offset = u, o.$u = 0 === s, o;
				if (0 !== s) {
					var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
				} else o = this.utc();
				return o;
			};
			var h = u.format;
			u.format = function(t) {
				var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return h.call(this, i);
			}, u.valueOf = function() {
				var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * t;
			}, u.isUTC = function() {
				return !!this.$u;
			}, u.toISOString = function() {
				return this.toDate().toISOString();
			}, u.toString = function() {
				return this.toDate().toUTCString();
			};
			var l = u.toDate;
			u.toDate = function(t) {
				return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
			};
			var c = u.diff;
			u.diff = function(t, i, e) {
				if (t && this.$u === t.$u) return c.call(this, t, i, e);
				var s = this.local(), f = n(t).local();
				return c.call(s, f, i, e);
			};
		};
	}));
}));
require_nl();
require_it();
require_fr();
var import_dayjs_min = /* @__PURE__ */ __toESM(require_dayjs_min(), 1);
var import_calendar = /* @__PURE__ */ __toESM(require_calendar(), 1);
var import_customParseFormat = /* @__PURE__ */ __toESM(require_customParseFormat(), 1);
var import_isBetween = /* @__PURE__ */ __toESM(require_isBetween(), 1);
var import_isLeapYear = /* @__PURE__ */ __toESM(require_isLeapYear(), 1);
var import_timezone = /* @__PURE__ */ __toESM(require_timezone(), 1);
var import_utc = /* @__PURE__ */ __toESM(require_utc(), 1);
import_dayjs_min.default.extend(import_customParseFormat.default);
import_dayjs_min.default.extend(import_isLeapYear.default);
import_dayjs_min.default.extend(import_calendar.default);
import_dayjs_min.default.extend(import_utc.default);
import_dayjs_min.default.extend(import_isBetween.default);
import_dayjs_min.default.extend(import_timezone.default);
import_dayjs_min.default.locale("nl");
import_dayjs_min.default.tz.setDefault("Europe/Amsterdam");
var dayjs = import_dayjs_min.default;
//#endregion
//#region src/date/dayOfWeek/isMonday.ts
var dateIsMonday = (date) => {
	return dayjs(date).day() === p.Monday;
};
//#endregion
//#region src/date/daysToPreviousBusinessDay/daysToPreviousBusinessDay.ts
/**
* Calculates the number of days to subtract based on the current day of the week.
*
* - If the current day is Sunday, subtract 2 days.
* - If the current day is Monday, subtract 3 days.
* - For all other days, subtract 1 day.
*
* @param {number} currentDay - The current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday).
* @returns {number} The number of days to subtract.
*/
var getDaysToPreviousBusinessDay = (currentDay) => {
	if (currentDay === p.Sunday) return 2;
	if (currentDay === p.Monday) return 3;
	return 1;
};
//#endregion
//#region src/delivery/isDelivery.ts
var isEarlyMorningDelivery = (deliveryType) => {
	return deliveryType === c.EarlyMorning;
};
var isMorningDelivery = (deliveryType) => {
	return deliveryType === c.Morning;
};
var isEveningDelivery = (deliveryType) => {
	return deliveryType === c.Evening;
};
var isPickupDelivery = (deliveryType) => {
	return [c.Pickup, c.PickupExpress].includes(deliveryType);
};
var isAdjustedDelivery = (deliveryType) => {
	return [
		c.EarlyMorning,
		c.Morning,
		c.Standard,
		c.Evening,
		c.SameDayDelivery,
		c.Express
	].includes(deliveryType);
};
//#endregion
//#region src/dimensions/dm3.ts
var calculateVolume = ({ length = 0, width = 0, height = 0 }) => {
	return length * width * height;
};
var calculateDm3 = ({ length = 0, width = 0, height = 0 }) => {
	return calculateVolume({
		length,
		width,
		height
	}) / 1e3;
};
//#endregion
//#region src/errors/index.ts
var formatObjectErrors = (errorKeys, error) => {
	return errorKeys.map((key) => {
		const value = error[key];
		if (typeof value === "string") return {
			code: parseInt(key),
			message: value
		};
		return {
			...value,
			code: parseInt(key)
		};
	});
};
/**
* We currently get the error codes in three different formats from the API.
* @example
*   1. [{code: 123, message: 'error message'}, {code: 456, message: 'error message'}]
*   2. [{123: 'error message', 456: 'error message'}]
*   3. [{123: {message: 'error message'}, 456: {message: 'error message'}}]
* @returns (same as format 1)
*   - [{code: 123, message: 'error message'}, {code: 456, message: 'error message'}]
*/
var flattenErrors = (errors) => {
	return errors.data?.errors.flatMap((error) => {
		if (error.code) return error;
		return formatObjectErrors(Object.keys(error), error);
	});
};
var getIndexesFromErrors = (error) => {
	if (!error.fields) return [];
	const indexes = [];
	error.fields.forEach((field) => {
		const splitByBrackets = field.split(/[\[\]]/g).filter(Boolean);
		const index = splitByBrackets[splitByBrackets.length - 1];
		indexes.push(parseInt(index));
	});
	return indexes;
};
//#endregion
//#region src/file/downloadBlob.ts
/**
* download a file
*
* @param blob
* @param fileName
*/
var downloadBlob = (blob, fileName) => {
	const tempLink = document.createElement("a");
	const url = window.URL.createObjectURL(blob);
	tempLink.href = url;
	tempLink.download = fileName;
	tempLink.target = "_blank";
	tempLink.click();
	tempLink.remove();
	window.URL.revokeObjectURL(url);
};
//#endregion
//#region src/file/downloadUrl.ts
var downloadUrl = (url, fileName) => {
	const tempLink = document.createElement("a");
	tempLink.href = url;
	tempLink.download = fileName;
	tempLink.click();
	tempLink.remove();
};
//#endregion
//#region src/file/print.ts
var RENDER_DELAY_MS = 150;
var CLEANUP_TIMEOUT_MS = 6e4;
var print = (printJob) => {
	return new Promise((resolve) => {
		const blobUrl = URL.createObjectURL(printJob);
		const iframe = document.createElement("iframe");
		iframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;";
		iframe.src = blobUrl;
		iframe.onload = () => {
			const printWindow = iframe.contentWindow;
			if (!printWindow) {
				URL.revokeObjectURL(blobUrl);
				/* c8 ignore if - Defensive check to ensure iframe is still in the document before attempting removal. */
				if (document.body.contains(iframe)) document.body.removeChild(iframe);
				resolve();
				return;
			}
			setTimeout(() => {
				printWindow.focus();
				printWindow.print();
				resolve();
				setTimeout(() => {
					URL.revokeObjectURL(blobUrl);
					if (document.body.contains(iframe)) document.body.removeChild(iframe);
				}, CLEANUP_TIMEOUT_MS);
			}, RENDER_DELAY_MS);
		};
		iframe.onerror = () => {
			URL.revokeObjectURL(blobUrl);
			/* c8 ignore if - Defensive check to ensure iframe is still in the document before attempting removal. */
			if (document.body.contains(iframe)) document.body.removeChild(iframe);
			resolve();
		};
		document.body.appendChild(iframe);
	});
};
//#endregion
//#region src/file/printOrDownload.ts
var printOrDownload = async (content, config) => {
	if (config.shouldPrint) return print(content);
	else return downloadBlob(content, config.filename);
};
//#endregion
//#region src/file/index.ts
/* c8 ignore start */
var file = {
	print,
	downloadBlob,
	downloadUrl,
	printOrDownload
};
//#endregion
//#region src/formatters/currency/format.ts
var format = (amount, { locale = "nl-NL", currency = "EUR", ...options } = {}) => new Intl.NumberFormat(locale, {
	style: "currency",
	currency,
	...options
}).format(amount / 100);
//#endregion
//#region src/formatters/currency/fromMoney.ts
var fromMoney = (money) => {
	if (!money) return 0;
	if (typeof money.micros === "number") return money.micros / 1e4;
	return (money.integral ?? 0) * 100 + (money.fractional ?? 0);
};
//#endregion
//#region src/formatters/currency/rounded.ts
/**
* Format a price in a rounded currency format.
* Adds a comma and removes decimals.
* @example
* roundedCurrency(9995) // => '€ 99,-'
*/
var rounded = (price) => {
	return `${format(price, {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	})},-`;
};
//#endregion
//#region src/formatters/currency/toCents.ts
var toCents = (value) => Math.round(value * 100);
//#endregion
//#region src/formatters/currency/toMoney.ts
var toMoney = (amountInCents, currency) => {
	const micros = Math.round(amountInCents * 1e4);
	const normalizedAmountInCents = Math.floor(micros / 1e4);
	return {
		currency: currency ?? "EUR",
		integral: Math.floor(normalizedAmountInCents / 100),
		fractional: normalizedAmountInCents % 100,
		micros
	};
};
//#endregion
//#region src/formatters/currency/toNumberFromSegments.ts
/**
* @deprecated Use {@link fromMoney} instead. Tracked for removal in OFF-3072 micros migration.
*/
var toNumberFromSegments = (priceParam) => {
	if (!priceParam) return 0;
	const integral = priceParam?.integral ?? 0;
	const fractional = priceParam?.fractional ?? 0;
	return integral * 100 + fractional;
};
//#endregion
//#region src/formatters/currency/toNumberFromString.ts
var toNumberFromString = (input) => {
	const trimmedInput = input?.trim() ?? "";
	const decimalSeparatorIndex = Math.max(trimmedInput.lastIndexOf("."), trimmedInput.lastIndexOf(","));
	if (decimalSeparatorIndex >= 0) {
		let integerPart = trimmedInput.substring(0, decimalSeparatorIndex);
		let fractionalPart = trimmedInput.substring(decimalSeparatorIndex + 1);
		integerPart = integerPart.replace(/[.,]/g, "");
		if (fractionalPart.length < 2) fractionalPart = fractionalPart.padEnd(2, "0");
		else if (fractionalPart.length > 2) fractionalPart = fractionalPart.substring(0, 2);
		return parseInt(integerPart + fractionalPart, 10);
	}
	return parseInt(trimmedInput.replace(/[.,]/g, ""), 10);
};
//#endregion
//#region src/formatters/currency/toSegments.ts
/**
* Converts an amount in cents to an object with integral (euros) and fractional (cents) parts.
*
* @param {number} amount - The amount in cents to be converted.
* @returns {Object} An object containing the integral and fractional parts.
* @returns {number} return.integral - The integral part of the amount, representing euros.
* @returns {number} return.fractional - The fractional part of the amount, representing remaining cents.
* @deprecated Use {@link toMoney} instead. Tracked for removal in OFF-3072 micros migration.
*/
var toSegments = (amountInCents) => {
	return {
		integral: Math.floor(amountInCents / 100),
		fractional: amountInCents % 100
	};
};
//#endregion
//#region src/formatters/currency/index.ts
/* c8 ignore start */
var currency = {
	format,
	fromMoney,
	rounded,
	toCents,
	toMoney,
	toNumberFromSegments,
	toNumberFromString,
	toSegments
};
//#endregion
//#region src/formatters/dimensions/toCentimeters.ts
var toCentimeters = (value, unit) => {
	switch (unit) {
		case w.Millimeter:
		case Nt.Millimeter: return value * Pt[w.Millimeter];
		case w.Centimeter:
		case Nt.Centimeter: return value;
		case w.Meter:
		case Nt.Meter: return value * Pt[w.Meter];
		default: throw new Error(`Unknown unit ${unit}`);
	}
};
//#endregion
//#region src/formatters/dimensions/index.ts
/* c8 ignore start */
var dimensions = { toCentimeters };
//#endregion
//#region src/formatters/fileSize/toBytes.ts
var toBytes = (bytes) => {
	if (!bytes) return "0 b";
	const byte = 1024;
	const sizes = [
		"b",
		"kb",
		"mb",
		"gb"
	];
	/**
	* calculate how many times the `bytes` param needs to be divided by 1024.
	*
	* e.g:
	* 1000 bytes = 1000 bytes, because it is below 1024
	* 1024 bytes = ~1kb, so it needs to be divided once
	* 1048576 bytes = ~1mb, so it needs to be divided two times to get the value in mb's.
	*/
	const times = Math.floor(Math.log(bytes) / Math.log(byte));
	return `${Math.round(bytes / byte ** times * 100) / 100} ${sizes[times]}`.replace(".", ",");
};
//#endregion
//#region src/formatters/fileSize/index.ts
/* c8 ignore start */
var fileSize = { toBytes };
//#endregion
//#region src/formatters/number/formatCompactNumber.ts
/**
* Formats a number into a compact representation for use in badges and small UI elements.
*
* Numbers below 1000 are returned as-is (e.g. 999 → "999").
* Numbers 1000+ are divided by 1000 and suffixed with "k":
*   - Whole thousands drop the decimal (e.g. 1000 → "1k", 48000 → "48k")
*   - Non-whole thousands keep one decimal (e.g. 1200 → "1.2k", 15300 → "15.3k")
*/
var formatCompactNumber = (value) => {
	if (value < 1e3) return String(value);
	const divided = value / 1e3;
	if (divided % 1 !== 0) return `${divided.toFixed(1).replace(/\.0$/, "")}k`;
	return `${divided}k`;
};
//#endregion
//#region src/formatters/number/toCeiledDecimal.ts
var toCeiledDecimal = (value, decimals = 1) => {
	const factor = Math.pow(10, decimals);
	return Math.ceil(value * factor) / factor;
};
//#endregion
//#region src/formatters/number/index.ts
/* c8 ignore start */
var number = {
	toCeiledDecimal,
	formatCompactNumber
};
//#endregion
//#region src/formatters/time/toTime.ts
var toTime = (time, format) => dayjs(time, "HH:mm:ss").format(format);
//#endregion
//#region src/formatters/time/index.ts
/* c8 ignore start */
var time = { toTime };
//#endregion
//#region src/formatters/url/parseUrlFromDoubleSlashes.ts
/**
* Parse the url by removing the doubleSlashes from the second occurrence
*/
var parseUrlFromDoubleSlashes = (url) => url.replace(/([^:]\/)\/+/g, "$1");
//#endregion
//#region src/formatters/url/index.ts
/* c8 ignore start */
var url = { parseUrlFromDoubleSlashes };
//#endregion
//#region src/formatters/weight/toGrams.ts
var toGrams = (value, unit) => {
	switch (unit) {
		case C.Gram:
		case jt.Gram: return value;
		case C.Kilogram:
		case jt.Kilogram: return value * Mt[C.Kilogram];
		default: throw new Error(`Unknown unit ${unit}`);
	}
};
//#endregion
//#region src/formatters/weight/toKilograms.ts
var toKilograms = (value, unit) => {
	switch (unit) {
		case jt.Gram:
		case C.Gram: return value / Mt[C.Kilogram];
		case C.Kilogram:
		case jt.Kilogram: return value;
		default: throw new Error(`Unknown unit ${unit}`);
	}
};
//#endregion
//#region src/formatters/weight/toString.ts
var toString = (value, unit, options = { round: true }) => {
	if (unit === jt.Gram) return `${value}g`;
	if (unit === jt.Kilogram) return `${options.round ? Math.round(value) : value}kg`;
	throw new Error(`Unknown unit ${unit}`);
};
//#endregion
//#region src/formatters/weight/toMinMaxString.ts
var toMinMaxString = (min, max, unit) => {
	if (unit === jt.Kilogram) {
		min = toKilograms(min, jt.Gram);
		max = toKilograms(max, jt.Gram);
	}
	return `${toString(min, unit)} - ${toString(max, unit)}`;
};
//#endregion
//#region src/formatters/index.ts
/* c8 ignore start */
var formatters = {
	currency,
	dimensions,
	weight: {
		toGrams,
		toKilograms,
		toString,
		toMinMaxString
	},
	time,
	url,
	fileSize,
	number
};
//#endregion
//#region src/language/formatLanguageOptions/formatLanguageOptions.ts
var formatLanguageOptions = (supportedLanguages, defaultLanguage) => {
	if (!supportedLanguages || supportedLanguages.length === 0) return [];
	return supportedLanguages.map((language) => ({
		code: language,
		countryCode: language
	})).sort((a, b) => a.code === defaultLanguage ? -1 : b.code === defaultLanguage ? 1 : 0);
};
//#endregion
//#region src/language/index.ts
/* c8 ignore start */
var language = { formatLanguageOptions };
//#endregion
//#region src/object/get/get.ts
/**
* Get value from object by path
*
* @example
* const object = {
*  a: {
*   b: {
*    c: 1
*   }
*  }
* }
*
* get(object, 'a.b.c') // 1
* get(object, 'a.b.d') // undefined
* get(object, 'a.b.d', 2) // 2
*/
function get(data, path, defaultValue) {
	const value = path.split(/[.[\]]/).filter(Boolean).reduce((value, key) => value?.[key], data);
	return value !== void 0 ? value : defaultValue;
}
//#endregion
//#region src/object/set/set.ts
var set = (obj, path, value) => {
	const keys = path.split(".");
	const lastKey = keys.pop();
	const keyIsArrayRegex = /\[(\d+)\]/;
	let current = obj;
	for (const key of keys) current = current[key] ??= {};
	const arrayMatch = lastKey.match(keyIsArrayRegex);
	if (arrayMatch) {
		const index = Number(arrayMatch[1]);
		const key = lastKey.replace(keyIsArrayRegex, "");
		current[key] = Array.isArray(current[key]) ? current[key] : [];
		current[key][index] = value;
		return obj;
	}
	current[lastKey] = value;
	return obj;
};
//#endregion
//#region src/mapping/mapFields/mapFields.ts
var mapFields = (source, mapping, removeEmptyValues = false) => {
	const result = {};
	for (const [sourceField, targetField] of mapping) {
		if (!targetField) continue;
		const value = get(source, sourceField);
		if (removeEmptyValues && value === void 0) continue;
		set(result, targetField, value ?? "");
	}
	return result;
};
//#endregion
//#region src/mapping/index.ts
/* c8 ignore start */
var mapping = { mapFields };
//#endregion
//#region src/object/clone/clone.ts
var clone = (object) => {
	return { ...object };
};
//#endregion
//#region src/object/filter/filterKeysFromObject.ts
var filterKeysFromObject = (obj, excludedKeys) => {
	return Object.keys(obj).reduce((acc, key) => {
		if (!excludedKeys.includes(key)) acc[key] = obj[key];
		return acc;
	}, {});
};
//#endregion
//#region src/object/flatten/flattenObject.ts
var flattenObject = (obj) => {
	function flat(res, key, val, pre = "") {
		const prefix = [pre, key].filter((v) => v).join(".");
		return typeof val === "object" && !Array.isArray(val) ? Object.keys(val).reduce((prev, curr) => flat(prev, curr, val[curr], prefix), res) : Object.assign(res, { [prefix]: val });
	}
	return Object.keys(obj).reduce((prev, curr) => flat(prev, curr, obj[curr]), {});
};
//#endregion
//#region src/object/pick/pick.ts
/**
* Pick object properties by keys
*
* @example
* const object = {
*  a: 1,
*  b: 2,
*  c: 3
* }
*
* pick(object, ['a', 'c']) // { a: 1, c: 3 }
*/
var pick = (object, keys) => {
	return keys.reduce((acc, key) => {
		const value = get(object, key);
		if (value !== void 0) acc[key] = value;
		return acc;
	}, {});
};
//#endregion
//#region src/object/pickRename/pickRename.ts
/**
* Pick object properties by keys and rename them.
*
* @param object - Object to pick properties from
* @param keys - Object with keys to pick and value to rename to
*
* @example
* const object = {
* a: 1,
* b: 2,
* c: 3
* }
*
* pickRename(object, {a: 'aa', c: 'cc'}) // {aa: 1, cc: 3}
*/
var pickRename = (object, keys) => {
	const pickedValues = pick(object, Object.keys(keys));
	return Object.entries(keys).reduce((acc, [key, newKey]) => {
		const pickedValue = pickedValues[key];
		if (pickedValue !== void 0) acc[newKey] = pickedValue;
		return acc;
	}, {});
};
//#endregion
//#region src/object/index.ts
var object = {
	clone,
	get,
	pick,
	pickRename,
	flatten: flattenObject,
	filterKeysFromObject,
	set
};
//#endregion
//#region src/parsers/base64ToBlob.ts
var base64ToBlob = (base64, mime = "application/pdf") => {
	const binaryString = atob(base64);
	const binaryLength = binaryString.length;
	const bytes = new Uint8Array(binaryLength);
	for (let i = 0; i < binaryLength; i++) bytes[i] = binaryString.charCodeAt(i);
	return new Blob([bytes], { type: mime });
};
//#endregion
//#region src/parsers/parseQueryParams.ts
/**
* @example
* parseQueryParams({
*  'page': '1',
*  'size': '25',
*  'barcode': 'test',
*  'delivered': 'true',
*  'carrier': '1;2;3;4',
* })
* // returns
* {
*  page: 1,
* size: 25,
* delivered: true,
* barcode: 'test',
* carrier: [1, 2, 3, 4],
* }
*/
var parseQueryParams = (query) => {
	const parsedQuery = {};
	Object.entries(query).forEach(([key, value]) => {
		if (value.includes(";")) parsedQuery[key] = value.split(";").map((item) => parse(item));
		else parsedQuery[key] = parse(value);
	});
	return parsedQuery;
};
var parse = (value) => {
	const isBoolean = value === "true" || value === "false";
	const isNumber = !isNaN(Number(value));
	if (isBoolean) return value === "true";
	if (isNumber) return Number(value);
	return value;
};
//#endregion
//#region src/parsers/stringToBoolean.ts
/**
* Converts a string to a boolean value.
* Recognizes "true", "1" (case-insensitive) as true.
* Recognizes "false", "0" (case-insensitive) as false.
* Returns null for any other input.
*
* @param {string} str - The string to convert.
* @returns {boolean|null} - The converted boolean value, or null if the input is unrecognized.
*/
function stringToBoolean(str) {
	if (typeof str === "boolean") return str;
	if (typeof str !== "string") return null;
	const normalizedStr = str.trim().toLowerCase();
	if (["true", "1"].includes(normalizedStr)) return true;
	if (["false", "0"].includes(normalizedStr)) return false;
	return null;
}
//#endregion
//#region ../../node_modules/.pnpm/es-toolkit@1.50.0/node_modules/es-toolkit/dist/string/trimEnd.mjs
/**
* Removes trailing whitespace or specified characters from a string.
*
* If `chars` is a string, it should be a single character. To trim a string with multiple characters,
* provide an array instead.
*
* @param str - The string from which trailing characters will be trimmed.
* @param chars - The character(s) to remove from the end of the string.
* @returns The resulting string after the specified trailing character has been removed.
*
* @example
* const trimmedStr1 = trimEnd('hello---', '-') // returns 'hello'
* const trimmedStr2 = trimEnd('123000', '0') // returns '123'
* const trimmedStr3 = trimEnd('abcabcabc', 'c') // returns 'abcabcab'
* const trimmedStr4 = trimEnd('trimmedxxx', 'x') // returns 'trimmed'
*/
function trimEnd(str, chars) {
	if (chars === void 0) return str.trimEnd();
	let endIndex = str.length;
	switch (typeof chars) {
		case "string":
			if (chars.length !== 1) throw new Error(`The 'chars' parameter should be a single character string.`);
			while (endIndex > 0 && str[endIndex - 1] === chars) endIndex--;
			break;
		case "object": while (endIndex > 0 && chars.includes(str[endIndex - 1])) endIndex--;
	}
	return str.substring(0, endIndex);
}
//#endregion
//#region ../../node_modules/.pnpm/es-toolkit@1.50.0/node_modules/es-toolkit/dist/string/trimStart.mjs
/**
* Removes leading whitespace or specified characters from a string.
*
* If `chars` is a string, it should be a single character. To trim a string with multiple characters,
* provide an array instead.
*
* @param str - The string from which leading characters will be trimmed.
* @param chars - The character(s) to remove from the start of the string.
* @returns The resulting string after the specified leading character has been removed.
*
* @example
* const trimmedStr1 = trimStart('---hello', '-') // returns 'hello'
* const trimmedStr2 = trimStart('000123', '0') // returns '123'
* const trimmedStr3 = trimStart('abcabcabc', 'a') // returns 'bcabcabc'
* const trimmedStr4 = trimStart('xxxtrimmed', 'x') // returns 'trimmed'
*/
function trimStart(str, chars) {
	if (chars === void 0) return str.trimStart();
	let startIndex = 0;
	switch (typeof chars) {
		case "string":
			if (chars.length !== 1) throw new Error(`The 'chars' parameter should be a single character string.`);
			while (startIndex < str.length && str[startIndex] === chars) startIndex++;
			break;
		case "object": while (startIndex < str.length && chars.includes(str[startIndex])) startIndex++;
	}
	return str.substring(startIndex);
}
//#endregion
//#region ../../node_modules/.pnpm/es-toolkit@1.50.0/node_modules/es-toolkit/dist/string/trim.mjs
/**
* Removes leading and trailing whitespace or specified characters from a string.
*
* @param str - The string from which characters will be trimmed.
* @param chars - The character(s) to remove from the string. Can be a single character or an array of characters.
* @returns The resulting string after the specified characters have been removed.
*
* @example
* trim("  hello  "); // "hello"
* trim("--hello--", "-"); // "hello"
* trim("##hello##", ["#", "o"]); // "hell"
*/
function trim$1(str, chars) {
	if (chars === void 0) return str.trim();
	return trimStart(trimEnd(str, chars), chars);
}
//#endregion
//#region ../../node_modules/.pnpm/es-toolkit@1.50.0/node_modules/es-toolkit/dist/compat/string/trim.mjs
function trim(str, chars, guard) {
	if (str == null) return "";
	if (guard != null || chars == null) return str.toString().trim();
	switch (typeof chars) {
		case "object": if (Array.isArray(chars)) return trim$1(str, chars.flatMap((x) => x.toString().split("")));
		else return trim$1(str, chars.toString().split(""));
		default: return trim$1(str, chars.toString().split(""));
	}
}
//#endregion
//#region src/parsers/toNumber.ts
/** Parse a plain number, allowing a comma decimal ("9,99" -> 9.99). */
var toNumber = (value) => Number(trim(value).replace(",", "."));
//#endregion
//#region src/parsers/toInt.ts
/** Parse a rounded integer; undefined when the value is empty so the field can be omitted. */
var toInt = (value) => {
	return trim(value) === "" ? void 0 : Math.round(toNumber(value));
};
//#endregion
//#region src/parsers/toIntBoolean.ts
var toIntBoolean = (value) => {
	return value ? 1 : 0;
};
//#endregion
//#region src/parsers/index.ts
/* c8 ignore start */
var parsers = {
	toIntBoolean,
	stringToBoolean,
	base64ToBlob,
	parseQueryParams,
	toNumber,
	toInt
};
//#endregion
//#region src/preventFloatyValues/preventFloatyValues.ts
var preventFloatyValues = (e) => {
	if (e.data && /[^0-9]/.test(e.data)) e.preventDefault();
};
//#endregion
//#region src/regex/index.ts
var regex = {
	url: /^(http|https):\/\/[^ "]+$/,
	phone: /^(\(?(?:\+|0{0,2})(?:\d+|\d-\d{1,3})\)?[- ]?(?:\d+[ -]?)+\d+)$/,
	email: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
};
//#endregion
//#region src/sorters/alphabetical/alphabetical.ts
/**
* Sorts strings alphabetically
*/
var ascending$1 = (a, b) => a.localeCompare(b);
/**
* Sorts strings alphabetically in reverse
*/
var descending$1 = (a, b) => b.localeCompare(a);
/**
* A value is "special" when its first character is not a letter or number.
*/
var startsWithSpecialCharacter = (value) => !/^[\p{L}\p{N}]/u.test(value);
/**
* Sort by the given property.
* This can be a nested property.
*/
var byProperty$2 = (property, options = { order: "ASC" }) => (a, b) => {
	const aProperty = object.get(a, property);
	const bProperty = object.get(b, property);
	const directionFn = options.order === "ASC" ? ascending$1 : descending$1;
	if (!aProperty) return options.order === "ASC" ? 1 : -1;
	if (!bProperty) return options.order === "ASC" ? -1 : 1;
	if (options.specialCharactersLast) {
		const aSpecial = startsWithSpecialCharacter(aProperty);
		if (aSpecial !== startsWithSpecialCharacter(bProperty)) return aSpecial ? 1 : -1;
	}
	return directionFn(aProperty, bProperty);
};
var alphabetical = {
	ascending: ascending$1,
	descending: descending$1,
	byProperty: byProperty$2
};
//#endregion
//#region src/sorters/customOrder/customOrder.ts
/**
* Sort by position in a predefined order list.
* Values not present in the order list are placed at the end.
*/
var byValue = (order = []) => (a, b) => {
	const aIndex = order.indexOf(a);
	const bIndex = order.indexOf(b);
	if (aIndex === -1 && bIndex === -1) return 0;
	if (aIndex === -1) return 1;
	if (bIndex === -1) return -1;
	return aIndex - bIndex;
};
/**
* Sort by the given property using a predefined order list.
* This can be a nested property. Values not present in the order list are placed at the end.
*/
var byProperty$1 = (property, order = []) => (a, b) => {
	const aValue = object.get(a, property) ?? "";
	const bValue = object.get(b, property) ?? "";
	const aIndex = order.indexOf(aValue);
	const bIndex = order.indexOf(bValue);
	if (aIndex === -1 && bIndex === -1) return 0;
	if (aIndex === -1) return 1;
	if (bIndex === -1) return -1;
	return aIndex - bIndex;
};
var customOrder = {
	byValue,
	byProperty: byProperty$1
};
//#endregion
//#region src/sorters/date/date.ts
/**
* Will sort a list by the given orderBy key which should be a property in the list array.
*/
var sortByDate = (list, orderBy, options = { order: "ASC" }) => {
	return list.sort((a, b) => {
		const dateA = dayjs(object.get(a, orderBy)).unix();
		const dateB = dayjs(object.get(b, orderBy)).unix();
		return options.order === "ASC" ? dateA - dateB : dateB - dateA;
	});
};
var date = { sortByDate };
//#endregion
//#region src/sorters/numeric/numeric.ts
/**
* Sorts numbers ascending.
*/
var ascending = (a, b) => a - b;
/**
* Sorts numbers descending.
*/
var descending = (a, b) => b - a;
/**
* Sorts numbers with trailing zero at the end.
*/
var trailingZero = (a, b) => {
	if (a === 0) return 1;
	if (b === 0) return -1;
	return a - b;
};
/**
* Sort by the given property.
* This can be a nested property.
*/
var byProperty = (property, options = { order: "ASC" }) => (a, b) => {
	const aProperty = object.get(a, property);
	const bProperty = object.get(b, property);
	if (aProperty === bProperty) return 0;
	const directionFn = options.order === "ASC" ? ascending : descending;
	if (aProperty === null || aProperty === void 0) return options.order === "ASC" ? 1 : -1;
	if (bProperty === null || bProperty === void 0) return options.order === "ASC" ? -1 : 1;
	return directionFn(aProperty, bProperty);
};
//#endregion
//#region src/sorters/index.ts
/* c8 ignore start */
var sorters = {
	numeric: {
		ascending,
		descending,
		trailingZero,
		byProperty
	},
	alphabetical,
	customOrder,
	date
};
//#endregion
//#region src/string/duplicate/duplicate.ts
var truncateString = (truncateAmount, originalObjectName) => {
	return originalObjectName.slice(0, originalObjectName.length - truncateAmount).trimEnd();
};
var getAllCopiesOfName = (array, name) => {
	const truncateAndSuffix = /\.\.\.[^.]*?$/;
	const suffixNumber = /\((\d+)\)/;
	return array.filter((element) => {
		const valueWithoutTruncateAndSuffix = element.replace(truncateAndSuffix, "").replace(suffixNumber, "").trimEnd();
		const truncatedName = truncateString(name.length + 8, name);
		return element.includes(name) || valueWithoutTruncateAndSuffix.includes(truncatedName);
	});
};
var constructSuffix = (array) => {
	const suffixNumber = /\((\d+)\)/;
	const highestValue = array.map((element) => {
		const match = element.match(suffixNumber);
		return match ? parseInt(match[1]) : 0;
	});
	return ` (${Math.max(...highestValue) + 1})`;
};
var duplicate = (nameToDuplicate, array, options = {}) => {
	const { truncateLength = 255, prefix = "Copy of " } = options;
	const truncate = "...";
	if (!array.length) throw new Error("Array to duplicate from is empty");
	const nameWithPrefix = `${prefix}${nameToDuplicate}`;
	const copies = getAllCopiesOfName(array, nameWithPrefix);
	const suffixValue = copies.length ? constructSuffix(copies) : "";
	const stringLength = nameWithPrefix.length + suffixValue.length;
	if (stringLength < truncateLength) return `${prefix}${nameToDuplicate}${suffixValue}`;
	return `${truncateString(stringLength - truncateLength + 3, nameWithPrefix)}${truncate}${suffixValue}`;
};
//#endregion
//#region src/string/hasContent/hasContent.ts
/** True when the value has non-whitespace content. */
var hasContent = (value) => trim(value) !== "";
//#endregion
//#region src/string/highlight/highlightSegments.ts
/**
* Splits `text` into segments around `query`
*/
var highlightSegments = (text, query) => {
	const term = query.trim();
	if (!term) return [{
		text,
		isHighlighted: false
	}];
	const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	const splitRegex = new RegExp(`(${escaped})`, "gi");
	return text.split(splitRegex).filter((chunk) => chunk.length).map((chunk) => ({
		text: chunk,
		isHighlighted: chunk.toLowerCase() === term.toLowerCase()
	}));
};
//#endregion
//#region src/string/index.ts
/* c8 ignore start */
var string = {
	duplicate,
	hasContent,
	highlightSegments
};
//#endregion
//#region src/units/getWeightFactor.ts
var getWeightFactor = (unit) => {
	switch (unit) {
		case "g":
		case C.Gram:
		case jt.Gram: return Mt[C.Gram];
		case C.Kilogram:
		case jt.Kilogram: return Mt[C.Kilogram];
		default: throw new Error(`Unknown weight unit: ${unit}`);
	}
};
//#endregion
//#region src/units/transformMetersToKilometers.ts
var transformMetersToKilometers = (meters) => {
	const kilometers = meters / 1e3;
	return kilometers % 1 === 0 ? kilometers : parseFloat(kilometers.toFixed(1));
};
//#endregion
//#region src/units/index.ts
/* c8 ignore start */
var units = {
	getWeightFactor,
	transformMetersToKilometers
};
//#endregion
//#region src/value/isObjectLike/isObjectLike.ts
var isObjectLike = (value) => value !== null && typeof value === "object";
//#endregion
//#region src/value/isArrayOfObjects/isArrayOfObjects.ts
var isArrayOfObjects = (value) => Array.isArray(value) && value.some((item) => isObjectLike(item));
//#endregion
//#region src/value/stringifyLeaf/stringifyLeaf.ts
var stringifyLeaf = (value) => Array.isArray(value) ? value.join(", ") : String(value);
//#endregion
//#region src/value/index.ts
/* c8 ignore start */
var value = {
	isObjectLike,
	isArrayOfObjects,
	stringifyLeaf
};
//#endregion
//#region src/wait/wait.ts
var wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
//#endregion
export { array, calculateDm3, cn, country, dateIsMonday, dayjs, file, findPriceForBracketRangeId, flattenErrors, formatters, getDaysToPreviousBusinessDay, getIndexesFromErrors, isAdjustedDelivery, isCustomProductBracketRange, isEarlyMorningDelivery, isEveningDelivery, isMorningDelivery, isPickupDelivery, isValidIban, language, mapping, object, parsers, pollUntil, preventFloatyValues, regex, retry, sorters, string, units, value, wait };

//# sourceMappingURL=index.js.map